<template>
  <div
    id="coin-manage"
    class="organization-account"
  >
    <el-container>
      <!-- :width="asideWidth + 'px'" isExpanded ?'auto': '270px' -->
      <!--  :style="{width :isExpanded ? '700px' : '330px'}" -->
      <div class="icontit_box">
        <div class="flex_o">
          <div class="flex_oclo">
            <div class="flex_o pad_5">
              <div>
                <svg
                  class="icon"
                  aria-hidden="true"
                >
                  <use xlink:href="#iconyuangongguanli2" />
                </svg>
              </div>
              <div>
                <svg
                  class="icon"
                  aria-hidden="true"
                >
                  <use xlink:href="#iconzuzhiguanli2" />
                </svg>
              </div>
            </div>
            <div class="gray_txt">
              空心彩色圖標
            </div>
          </div>
          <div class="flex_oclo mar_5">
            <div class="bla_txt">
              有員工/組別
            </div>
          </div>
        </div>
        <div class="flex_o rig_box">
          <div class="flex_oclo w_50">
            <div class="flex_o pad_6">
              <div>
                <svg
                  class="icon"
                  aria-hidden="true"
                >
                  <use xlink:href="#iconyuangongguanli1-copy-copy" />
                </svg>
              </div>
              <div>
                <svg
                  class="icon"
                  aria-hidden="true"
                >
                  <use xlink:href="#iconzuzhiguanli-copy-copy" />
                </svg>
              </div>
            </div>
            <div class="gray_txt">
              置灰圖標
            </div>
          </div>
          <div class="flex_oclo mar_5">
            <div class="bla_txt">
              沒有員工/組別
            </div>
          </div>
        </div>
      </div>
      <div class="account-header">
        <span class="departmet-name">{{ departmentName || '--' }}</span>
        <!-- v-show="$route.query.parId == 0 && $route.query.accId == 0 " -->
        <span class="pos-num">
          <span
            v-if="isUsedCoin"
            :class="{'coin-num':true,'anicon':$route.query.parId == 0 && $route.query.accId == 0 }"
          >
            <svg
              class="icon"
              aria-hidden="true"
              style="margin-right: 5px; font-size: 20px"
            >
              <use xlink:href="#iconjinbi" />
            </svg>
            金幣數量： {{ remainderPropertyCoin.toLocaleString() || '--' }}
          </span>
          <div
            v-show="$route.query.parId == 0 && $route.query.accId == 0"
            class="custom-tooltip"
          >
            你可以操作以下的<span v-if="isUsedDiamond && isUsedCoin">金幣或鑽石</span><span v-if="isUsedDiamond && !isUsedCoin">鑽石</span><span v-if="!isUsedDiamond && isUsedCoin">金幣</span>
          </div>
          <div
            v-show="$route.query.parId == 0 && $route.query.accId == 0"
            class="tringlebox"
          />
          <span
            v-if="isUsedDiamond"
            :class="{'diamond-num':true,'anicon':$route.query.parId == 0 && $route.query.accId == 0}"
          >
            <svg
              class="icon"
              aria-hidden="true"
              style="margin-right: 5px; font-size: 20px"
            >
              <use xlink:href="#iconzuanshi" />
            </svg>
            鑽石數量：{{ remainderDiamond.toLocaleString() || '--' }}
          </span>
        </span>
        <el-button
          v-if="permissions.Coin_CoinManage_Manager && isBuyCoin"
          type="warning"
          @click="buyCoin"
        >
          購買金幣
        </el-button>
        <el-button
          v-if="isBuyDiamond"
          type="primary"
          class="btn-diamond"
          @click="buyDiamond"
        >
          購買鑽石
        </el-button>
      </div>
      <el-aside
        :width="isExpanded ? '700px' : '270px'"
        :style="{ height: asideHeight + 'px' ,position :isExpanded?'absolute':'',zIndex:isExpanded?2:0,marginTop:showExpanded?90+'px':0}"
      >
        <aside-bar
          ref="asideBar"
          :is-expanded.sync="isExpanded"
          :current-selected.sync="currentSelected"
          :tree-data-list="treeData"
          :loading="treeLoading"
          :aside-height="asideHeight"
          @choose="choseOrganization"
        />
      </el-aside>
      <el-main>
        <!-- <div class="account-header">
                    <span class="departmet-name">{{ departmentName || '--' }}</span>
                    <span :class="{'coin-num':true,'anicon':$route.query.parId == 0 && $route.query.accId == 0 }" v-if="isUsedCoin">
                        <svg class="icon" aria-hidden="true" style="margin-right: 5px; font-size: 20px">
                            <use xlink:href="#iconjinbi" />
                        </svg>
                        金幣數量： {{ remainderPropertyCoin.toLocaleString() || '--' }}
                    </span>
                    <span :class="{'diamond-num':true,'anicon':$route.query.parId == 0 && $route.query.accId == 0}" v-if="isUsedDiamond">
                        <svg class="icon" aria-hidden="true" style="margin-right: 5px; font-size: 20px">
                            <use xlink:href="#iconzuanshi" />
                        </svg>
                        鑽石數量：{{ remainderDiamond.toLocaleString() || '--' }}
                    </span>
                    <el-button v-if="permissions.Coin_CoinManage_Manager && isBuyCoin" type="warning" @click="buyCoin">購買金幣</el-button>
                    <el-button v-if="isBuyDiamond" type="primary" @click="buyDiamond" class="btn-diamond">購買鑽石</el-button>
                </div> -->
        <div class="org-main">
          <!-- HOUSEMIS-4131 -->
          <div
            v-show="parentDep.departmentID"
            class="uplevel"
            @click="toUpLevel"
          >
            <i class="el-icon-arrow-left" />
            <span>回到上一層{{ currentSelected == 1 ? '組別' :'員工' }}頁({{ parentDep.departmentName }})</span>
          </div>
          <div class="classify-tab">
            <span class="btn-guide">
              <span
                :class="{'active':true, activeOrn: currentSelected === 2 }"
                @click="changeSelected('staff')"
              >
                員工
                <svg
                  class="icon"
                  aria-hidden="true"
                >
                  <use xlink:href="#iconyuangongguanli1-copy" />
                </svg>
              </span>
              <div class="line" />
              <span
                :class="{ 'active':true,activeGre: currentSelected === 1 }"
                @click="changeSelected('dep')"
              >
                組别
                <svg
                  class="icon"
                  aria-hidden="true"
                >
                  <use xlink:href="#iconzuzhiguanli-copy" />
                </svg>
              </span>
            </span>
          </div>

          <div class="tab-content">
            <!-- 组织 -->
            <div
              v-show="currentSelected === 1"
              class="container-tissue"
            >
              <!-- 組別查詢 -->
              <div class="search-condition">
                <el-select
                  v-model="status"
                  placeholder="組別狀態"
                  :class="['width100',{mr_15:status != 'normal' && status != 'disable'}]"
                >
                  <el-option
                    v-for="item in statusOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  />
                </el-select>
                <span
                  v-show="status == 'normal' || status == 'disable'"
                  :class="['gre_point',status == 'normal' || status == 'disable' ? 'mr_15':'']"
                />
                <span
                  v-if="isUsedCoin"
                  class="coin"
                >
                  <span>金幣數量：</span>
                  <el-input
                    v-model="coinNumMin"
                    placeholder="請輸入"
                    @input="coinNumMin = coinNumMin.replace(/[^\d]/g, '')"
                  />
                  <span class="gap">至</span>
                  <el-input
                    v-model="coinNumMax"
                    placeholder="請輸入"
                    @input="coinNumMax = coinNumMax.replace(/[^\d]/g, '')"
                  />
                </span>
                <span
                  v-if="isUsedDiamond"
                  class="diamond"
                >
                  <span>鑽石数量：</span>
                  <el-input
                    v-model="diamondNumMin"
                    placeholder="請輸入"
                    @input="diamondNumMin = diamondNumMin.replace(/[^\d]/g, '')"
                  />
                  <span class="gap">至</span>
                  <el-input
                    v-model="diamondNumMax"
                    placeholder="請輸入"
                    @input="diamondNumMax = diamondNumMax.replace(/[^\d]/g, '')"
                  />
                </span>
                <!--  -->
                <el-button
                  type="danger"
                  @click="search()"
                >
                  搜尋
                </el-button>
                <el-button
                  type="info"
                  @click="reset"
                >
                  重置
                </el-button>
              </div>
              <div class="wraper">
                <!-- 按钮 -->
                <div
                  v-if="permissions.Coin_CoinManage_Manager"
                  class="btns"
                >
                  <div
                    v-if="isUsedCoin"
                    class="coin"
                  >
                    <span
                      class="notall-guide"
                      style="margin-right: 10px; display: inline-block"
                    >
                      <el-button
                        :disabled="!operateAlldisabled"
                        @click="coinOperate('assign','coin')"
                      >分配金幣</el-button>
                      <el-button
                        :disabled="!operateAlldisabled"
                        @click="coinOperate('back','coin')"
                      >回收金幣</el-button>
                    </span>
                    <span
                      class="all-guide"
                      style="display: inline-block"
                    >
                      <el-tooltip
                        content="分配金幣給所有組別"
                        placement="top"
                      >
                        <el-button
                          :disabled="operateAlldisabled"
                          @click="coinOperate('assignAll','coin')"
                        >全部分配(金幣)</el-button>
                      </el-tooltip>
                      <el-tooltip
                        content="回收所有組別的金幣"
                        placement="top"
                      >
                        <el-button
                          :disabled="operateAlldisabled"
                          @click="backAllCoin('backAll')"
                        >全部回收(金幣)</el-button>
                      </el-tooltip>
                      <el-button @click="showTranCoinDia('coin')">轉移金幣</el-button>
                    </span>
                  </div>
                  <div
                    v-if="isUsedDiamond"
                    class="diamond"
                  >
                    <span
                      class="notall-guide"
                      style="margin-right: 10px; display: inline-block"
                    >
                      <el-button
                        :disabled="!operateAlldisabled"
                        @click="diamondOperate('assign','diamond')"
                      >分配鑽石</el-button>
                      <el-button
                        :disabled="!operateAlldisabled"
                        @click="diamondOperate('back','diamond')"
                      >回收鑽石</el-button>
                    </span>
                    <span
                      class="all-guide"
                      style="display: inline-block"
                    >
                      <el-tooltip
                        content="分配鑽石給所有組別"
                        placement="top"
                      >
                        <el-button
                          :disabled="operateAlldisabled"
                          @click="diamondOperate('assignAll','diamond')"
                        >全部分配(鑽石)</el-button>
                      </el-tooltip>
                      <el-tooltip
                        content="回收所有組別的鑽石"
                        placement="top"
                      >
                        <el-button
                          :disabled="operateAlldisabled"
                          @click="backAllDiamond('backAll')"
                        >全部回收(鑽石)</el-button>
                      </el-tooltip>
                      <el-button @click="showTranCoinDia('diamond')">轉移鑽石</el-button>
                    </span>
                  </div>
                </div>
                <!-- 組別 -->
                <div class="table-contain">
                  <el-table
                    ref="depTable"
                    v-loading="departmentLoading"
                    :data="tableData"
                    style="width: 100%"
                    empty-text="暫無數據"
                    @selection-change="handleSelectionChange"
                  >
                    <el-table-column
                      type="selection"
                      width="55"
                    />
                    <el-table-column
                      prop="departmentName"
                      label="組別"
                      show-overflow-tooltip
                    >
                      <template slot-scope="scope">
                        <span>
                          {{ scope.row.departmentName }}
                          <span
                            v-if="isApiSelectedRow(scope.row)"
                            class="tabtxt"
                          >
                            [管理員&nbsp;{{ $route.query.roleName }}]
                          </span>
                        </span>
                      </template>
                    </el-table-column>
                    <el-table-column
                      v-if="isUsedCoin"
                      prop="remainderPropertyCoin"
                      label="金幣數量"
                      :width="13 * 10"
                      show-overflow-tooltip
                    />
                    <el-table-column
                      v-if="isUsedDiamond"
                      prop="remainderDiamond"
                      label="鑽石數量"
                      :width="13 * 10"
                      show-overflow-tooltip
                    />
                    <el-table-column
                      prop="status"
                      label="組別狀態"
                      :width="13 * 6"
                      show-overflow-tooltip
                    >
                      <template slot-scope="scope">
                        {{ scope.row.status | statusTransition }}
                      </template>
                    </el-table-column>
                  </el-table>
                  <div class="pagination clearfix">
                    <div
                      v-if="false"
                      class="count"
                    >
                      <span>當前查詢記錄：{{ departmentTotal }}</span>
                      <span>總記錄：{{ departmentTotalCount }}</span>
                    </div>
                    <el-pagination
                      background
                      :page-size="departmentPageCount"
                      :page-sizes="[10, 20, 50, 100]"
                      :current-page.sync="departmentPageIndex"
                      layout=" total,sizes, prev, pager,next, jumper"
                      :total="departmentTotal"
                      @size-change="handleSizeChange"
                      @current-change="handleCurrentChange"
                    />
                  </div>
                </div>
              </div>
            </div>
            <!-- 员工 -->
            <div
              v-show="currentSelected === 2"
              class="container-staff"
            >
              <!-- 員工查詢 -->
              <div class="search-condition-staff">
                <el-select
                  v-model="roleId"
                  placeholder="角色"
                  :class="{mr_15:roleId == '' }"
                >
                  <el-option
                    v-for="item in roleOptions"
                    :key="item.roleID"
                    :label="item.roleName"
                    :value="item.roleID"
                  />
                </el-select>
                <span
                  v-show="roleId != ''"
                  :class="['gre_point',roleId != '' ? 'mr_15':'']"
                />
                <el-select
                  v-model="staffStatus"
                  placeholder="員工狀態"
                  :class="['width100',{mr_15:staffStatus != 'normal' && staffStatus != 'disable'}]"
                >
                  <el-option
                    v-for="item in staffStatusOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  />
                </el-select>
                <span
                  v-show="staffStatus == 'normal' || staffStatus == 'disable'"
                  :class="['gre_point',staffStatus == 'normal' || staffStatus == 'disable' ? 'mr_15':'']"
                />
                <el-input
                  v-model="staffName"
                  placeholder="員工姓名"
                  @keyup.enter.native="staffSearch"
                />
                <span
                  v-if="isUsedCoin"
                  class="coin"
                >
                  <span>金幣數量：</span>
                  <el-input
                    v-model="staffCoinNumMin"
                    class="width100"
                    placeholder="請輸入"
                    @input="staffCoinNumMin = staffCoinNumMin.replace(/[^\d]/g, '')"
                  />
                  <span class="gap">至</span>
                  <el-input
                    v-model="staffCoinNumMax"
                    class="width100"
                    placeholder="請輸入"
                    @input="staffCoinNumMax = staffCoinNumMax.replace(/[^\d]/g, '')"
                  />
                </span>
                <span
                  v-if="isUsedDiamond"
                  class="dianmond"
                >
                  <span>鑽石数量：</span>
                  <el-input
                    v-model="staffDiamondNumMin"
                    placeholder="請輸入"
                    @input="staffDiamondNumMin = staffDiamondNumMin.replace(/[^\d]/g, '')"
                  />
                  <span class="gap">至</span>
                  <el-input
                    v-model="staffDiamondNumMax"
                    placeholder="請輸入"
                    @input="staffDiamondNumMax = staffDiamondNumMax.replace(/[^\d]/g, '')"
                  />
                </span>
                <el-button
                  type="danger"
                  @click="staffSearch"
                >
                  搜尋
                </el-button>
                <el-button
                  type="info"
                  @click="staffReset"
                >
                  重置
                </el-button>
              </div>
              <div class="wraper">
                <div
                  v-if="permissions.Coin_CoinManage_Manager"
                  class="btns"
                >
                  <div
                    v-if="isUsedCoin"
                    class="coin"
                  >
                    <el-button
                      :disabled="!operateAlldisabled"
                      @click="coinOperate('assign','coin')"
                    >
                      分配金幣
                    </el-button>
                    <el-button
                      :disabled="!operateAlldisabled"
                      @click="coinOperate('back','coin')"
                    >
                      回收金幣
                    </el-button>
                    <el-tooltip
                      content="分配金幣給所有員工"
                      placement="top"
                    >
                      <el-button
                        :disabled="operateAlldisabled"
                        @click="coinOperate('assignAll','coin')"
                      >
                        全部分配(金幣)
                      </el-button>
                    </el-tooltip>
                    <el-tooltip
                      content="回收所有員工的金幣"
                      placement="top"
                    >
                      <el-button
                        :disabled="operateAlldisabled"
                        @click="backAllCoin('backAll')"
                      >
                        全部回收(金幣)
                      </el-button>
                    </el-tooltip>
                    <el-button @click="showTranCoinDia('coin')">
                      轉移金幣
                    </el-button>
                  </div>
                  <div
                    v-if="isUsedDiamond"
                    class="diamond"
                  >
                    <span
                      class="notall-guide notall-guides"
                      style="margin-right: 10px; display: inline-block"
                    >
                      <el-button
                        :disabled="!operateAlldisabled"
                        @click="diamondOperate('assign','diamond')"
                      >分配鑽石</el-button>
                      <el-button
                        :disabled="!operateAlldisabled"
                        @click="diamondOperate('back','diamond')"
                      >回收鑽石</el-button>
                    </span>
                    <span
                      class="all-guide all-guides"
                      style="display: inline-block"
                    >
                      <el-tooltip
                        content="分配鑽石給所有員工"
                        placement="top"
                      >
                        <el-button
                          :disabled="operateAlldisabled"
                          @click="diamondOperate('assignAll','diamond')"
                        >全部分配(鑽石)</el-button>
                      </el-tooltip>
                      <el-tooltip
                        content="回收所有員工的鑽石"
                        placement="top"
                      >
                        <el-button
                          :disabled="operateAlldisabled"
                          @click="backAllDiamond('backAll')"
                        >全部回收(鑽石)</el-button>
                      </el-tooltip>
                      <el-button @click="showTranCoinDia('diamond')">轉移鑽石</el-button>
                    </span>
                  </div>
                </div>
                <!-- 員工表格-->
                <div class="table-contain">
                  <el-table
                    ref="staffTable"
                    v-loading="staffLoading"
                    :data="staffTableData"
                    empty-text="暫無數據"
                    style="width: 100%"
                    @selection-change="handleSelectionChange"
                  >
                    <el-table-column
                      type="selection"
                      width="55"
                      :selectable="canSelectRow"
                    />
                    <el-table-column
                      label="員工名稱"
                      :width="13 * 14"
                    >
                      <template slot-scope="scope">
                        {{ scope.row.name ? scope.row.name : '-' }}
                      </template>
                    </el-table-column>
                    <el-table-column
                      prop="departmentName"
                      label="所屬組別"
                    />
                    <el-table-column
                      v-if="isUsedCoin"
                      prop="remainderPropertyCoin"
                      label="金幣數量"
                      :width="13 * 10"
                      show-overflow-tooltip
                    >
                      <template slot-scope="scope">
                        {{ scope.row.remainderPropertyCoin }}
                      </template>
                    </el-table-column>
                    <el-table-column
                      v-if="isUsedDiamond"
                      prop="remainderDiamond"
                      label="鑽石數量"
                      :width="13 * 10"
                      show-overflow-tooltip
                    >
                      <template slot-scope="scope">
                        {{ scope.row.remainderDiamond }}
                      </template>
                    </el-table-column>
                    <el-table-column
                      label="員工角色"
                      :width="13 * 8"
                      show-overflow-tooltip
                    >
                      <template slot-scope="scope">
                        {{ roleTransition[scope.row.roleID] }}
                      </template>
                    </el-table-column>
                    <el-table-column
                      prop="status"
                      label="員工狀態"
                      :width="13 * 6"
                      show-overflow-tooltip
                    >
                      <template slot-scope="scope">
                        {{ scope.row.status | statusTransition }}
                      </template>
                    </el-table-column>
                  </el-table>
                  <div class="pagination clearfix">
                    <div
                      v-if="false"
                      class="count"
                    >
                      <span>當前查詢記錄：{{ staffTotal }}</span>
                      <span>總記錄：{{ staffTotalCount }}</span>
                    </div>
                    <el-pagination
                      background
                      :page-size="staffPageCount"
                      :page-sizes="[10, 20, 50, 100]"
                      :current-page.sync="staffPageIndex"
                      layout="total,sizes,prev, pager,next, jumper"
                      :total="staffTotal"
                      @size-change="handleStaffSizeChange"
                      @current-change="handleStaffCurrentChange"
                    />
                  </div>
                </div>
              </div>
              <!-- 按钮 -->
            </div>
          </div>
        </div>
      </el-main>
    </el-container>
    <!-- 購買金幣彈框 -->
    <el-dialog
      title="購買金幣"
      :visible.sync="buyCoinDialogVisible"
      width="480px"
      class="buy-dialog"
    >
      <el-form
        ref="buyForm"
        label-width="170px"
        :model="buyCoinForm"
        :rules="buyCoinRules"
        hide-required-asterisk
      >
        <el-form-item
          label="請選擇購買金幣數量："
          prop="buyCoinNumId"
        >
          <el-select
            v-model="buyCoinForm.buyCoinNumId"
            placeholder="請選擇"
          >
            <el-option
              label="自訂金額"
              value="self"
            />
            <el-option
              v-for="item in coinNumOptions"
              :key="item.setID"
              :label="`${item.propertyCoin}金幣-HK$${item.money}`"
              :value="item.setID"
            />
          </el-select>
        </el-form-item>
        <el-form-item
          v-if="buyCoinForm.buyCoinNumId === 'self'"
          label="金幣數量："
          prop="buyCoinNum"
        >
          <div class="row">
            <el-input
              v-model.number="buyCoinForm.buyCoinNum"
              placeholder="請輸入金幣數量"
              maxlength="6"
              @input="getMoneny"
            />
            <span class="money">HK${{ customeMoney ? customeMoney : '--' }}</span>
          </div>
        </el-form-item>
      </el-form>
      <span
        slot="footer"
        class="dialog-footer"
      >
        <el-button @click="buyCoinDialogVisible = false">取 消</el-button>
        <el-button
          type="primary"
          :loading="submittingCoin"
          @click="makeSureBuyCoin"
        >確認</el-button>
      </span>
    </el-dialog>
    <!-- 分配與回收金幣彈框 分配全部彈框 -->
    <el-dialog
      :title="operateType === 'assign' ? '分配金幣' : operateType === 'back' ? '回收金幣' : '分配全部(金幣)'"
      :visible.sync="coinOperateDialogVisible"
      width="480px"
      class="assign-dialog"
    >
      <el-form
        ref="coinOpetateform"
        :model="operateForm"
        label-width="100px"
      >
        <el-form-item
          label="金幣數量："
          prop="coinNum"
          :rules="operateRules.coinNum"
        >
          <el-input
            v-model.trim="operateForm.coinNum"
            placeholder="請輸入"
          />
        </el-form-item>
      </el-form>
      <span
        slot="footer"
        class="dialog-footer"
      >
        <el-button @click="coinOperateDialogVisible = false">取 消</el-button>
        <!-- 分配金幣 -->
        <el-button
          v-if="operateType === 'assign'"
          type="primary"
          @click="assignCoin"
        >確認</el-button>
        <!-- 回收金幣 -->
        <el-button
          v-else-if="operateType === 'back'"
          type="primary"
          @click="backCoin"
        >確認</el-button>
        <!-- 分配全部 -->
        <el-button
          v-else
          type="primary"
          @click="assignAll"
        >確認</el-button>
      </span>
    </el-dialog>
    <!-- 回收全部-->
    <el-dialog
      title="回收全部(金幣)"
      :visible.sync="backAllCoinDialogVisible"
      width="480px"
      class="assign-dialog"
    >
      <el-form
        ref="backAllForm"
        :model="backAllForm"
        label-width="100px"
      >
        <el-form-item
          label="回收方式："
          prop="backAllMethod"
          :rules="operateRules.backAllMethod"
        >
          <el-select
            v-model="backAllForm.backAllMethod"
            placeholder="請選擇"
          >
            <el-option
              key="all"
              label="回收賬戶全部金幣"
              value="all"
            />
            <el-option
              key="count"
              label="按數量回收金幣"
              value="count"
            />
          </el-select>
        </el-form-item>
        <el-form-item
          v-if="backAllForm.backAllMethod === 'count'"
          label="金幣數量："
          prop="backAllCoinNum"
          :rules="operateRules.backAllCoinNum"
        >
          <el-input
            v-model="backAllForm.backAllCoinNum"
            placeholder="請輸入"
          />
        </el-form-item>
      </el-form>
      <span
        slot="footer"
        class="dialog-footer"
      >
        <el-button @click="backAllCoinDialogVisible = false">取 消</el-button>
        <el-button
          type="primary"
          @click="makeSureBackAll"
        >確認</el-button>
      </span>
    </el-dialog>
    <!-- 購買砖石彈框 -->
    <el-dialog
      title="購買鑽石"
      :visible.sync="buyDiamondDialogVisible"
      width="480px"
      class="buy-dialog"
    >
      <el-form
        ref="buyDiamondForm"
        label-width="170px"
        :model="buyDiamondForm"
        :rules="buyDiamondRules"
        hide-required-asterisk
      >
        <el-form-item
          label="請選擇購買鑽石數量："
          prop="buyNumId"
        >
          <el-select
            v-model="buyDiamondForm.buyNumId"
            placeholder="請選擇"
          >
            <el-option
              label="自訂金額"
              value="self"
            />
            <el-option
              v-for="item in diamondNumOptions"
              :key="item.setID"
              :label="`${item.diamond}鑽石-HK$${item.money}`"
              :value="item.setID"
            />
          </el-select>
        </el-form-item>
        <el-form-item
          v-if="buyDiamondForm.buyNumId === 'self'"
          label="鑽石數量："
          prop="buyNum"
        >
          <div class="row">
            <el-input
              v-model.number="buyDiamondForm.buyNum"
              placeholder="請輸入鑽石數量"
              maxlength="6"
              @input="customDiamondInput"
            />
            <span class="money">HK${{ customDiamondMoney ? customDiamondMoney : '--' }}</span>
          </div>
        </el-form-item>
      </el-form>
      <span
        slot="footer"
        class="dialog-footer"
      >
        <el-button @click="buyDiamondDialogVisible = false">取 消</el-button>
        <el-button
          type="primary"
          :loading="submittingDiamond"
          @click="makeSureBuyDiamond"
        >確認</el-button>
      </span>
    </el-dialog>
    <!-- 分配與回收砖石彈框 分配全部彈框 -->
    <el-dialog
      :title="operateType === 'assign' ? '分配鑽石' : operateType === 'back' ? '回收鑽石' : '分配全部(鑽石)'"
      :visible.sync="diamondOperateDialogVisible"
      width="480px"
      class="assign-dialog"
    >
      <el-form
        ref="diamondOpeerateform"
        :model="diamondOperateForm"
        label-width="100px"
      >
        <el-form-item
          label="鑽石數量："
          prop="diamondNum"
          :rules="diamondOperateRules.diamondNum"
        >
          <el-input
            v-model.trim="diamondOperateForm.diamondNum"
            placeholder="請輸入"
          />
        </el-form-item>
      </el-form>
      <span
        slot="footer"
        class="dialog-footer"
      >
        <el-button @click="diamondOperateDialogVisible = false">取 消</el-button>
        <!-- 分配金幣 -->
        <el-button
          v-if="operateType === 'assign'"
          type="primary"
          @click="assignDiamond"
        >確認</el-button>
        <!-- 回收金幣 -->
        <el-button
          v-else-if="operateType === 'back'"
          type="primary"
          @click="backDiamond"
        >確認</el-button>
        <!-- 分配全部 -->
        <el-button
          v-else
          type="primary"
          @click="assignAllDiamond"
        >確認</el-button>
      </span>
    </el-dialog>
    <!-- 回收全部砖石-->
    <el-dialog
      title="回收全部(鑽石)"
      :visible.sync="backAllDiamondDialogVisible"
      width="480px"
      class="assign-dialog"
    >
      <el-form
        ref="diamondBackAllForm"
        :model="diamondBackAllForm"
        label-width="100px"
      >
        <el-form-item
          label="回收方式："
          prop="backAllMethod"
          :rules="diamondOperateRules.backAllMethod"
        >
          <el-select
            v-model="diamondBackAllForm.backAllMethod"
            placeholder="請選擇"
          >
            <el-option
              key="all"
              label="回收賬戶全部鑽石"
              value="all"
            />
            <el-option
              key="count"
              label="按數量回收鑽石"
              value="count"
            />
          </el-select>
        </el-form-item>
        <el-form-item
          v-if="diamondBackAllForm.backAllMethod === 'count'"
          label="鑽石數量："
          prop="backAllDiamondNum"
          :rules="diamondOperateRules.backAllDiamondNum"
        >
          <el-input
            v-model="diamondBackAllForm.backAllDiamondNum"
            placeholder="請輸入"
          />
        </el-form-item>
      </el-form>
      <span
        slot="footer"
        class="dialog-footer"
      >
        <el-button @click="backAllDiamondDialogVisible = false">取 消</el-button>
        <el-button
          type="primary"
          @click="makeSureBackAllDiamond"
        >確認</el-button>
      </span>
    </el-dialog>
        
    <el-dialog
      :close-on-click-modal="false"
      :title="`轉移${dialogTransCoinType =='coin' ? '金幣' : '鑽石'}`"
      :visible.sync="showDepCoin"
      width="800px"
      class="assign-dialog transfer_dialog"
      @open="openTransferDia"
    >
      <el-form
        ref="transferForm"
        :model="transferObj"
        :rules="transferRules"
      >            
        <div>
          <div
            v-show="transferObj.inDepChannels.length>1 || transferObj.inStaffChannels.length > 1 || transferObj.outDepChannels.length > 1 || transferObj.outStaffChannels.length > 1 "
            class="multip"
          >
            因{{ transferObj.inDepChannels.length>1 || transferObj.inStaffChannels.length > 1 ? '接收組別/人':'轉出組別/人' }}已選多於一個，{{ transferObj.inDepChannels.length>1 || transferObj.inStaffChannels.length > 1 ? '轉出組別/人':'接收組別/人' }}只能選一個
          </div>
          <span>轉出組別/人：</span>
          <span>
            <span class="btns_box">
              <span
                :class="['btns_dep','bor_lef',isOutDepartment? 'blu_btn':'']"
                @click="searchDepartment('out')"
              >組別</span>
              <span
                :class="['btns_dep','bor_rig',!isOutDepartment? 'blu_btn':'']"
                @click="searchCompanyUser('out')"
              >員工</span>
            </span>
            <el-form-item
              v-if="isOutDepartment"
              prop="outDepChannels"
              class="in_dep"
            >
              <coin-select
                :channels="transferObj.outDepChannels"
                :options="outDepOptions"
                label-name="departmentName"
                sel-val="departmentID"
                :mul-number="isInDepartment ? (transferObj.inDepChannels.length > 1 ? 1:0) : (transferObj.inStaffChannels.length > 1 ? 1 : 0)"
                placeholder="請搜索組別"
                :class-name="transferObj.outDepChannels.length > 1 ? 'custom-select':''"
                @update:channels="transferObj.outDepChannels = $event"
                @visible-change="selectSeeChannel('outDep', $event)"
                @filter-method="filterDepStaff('outDep', $event)"
              >
                <template #default="{ node, data }">
                  <!--  v-if="(transferObj.inDepChannels.length.length >= 1 && isInDepartment) || (transferObj.inStaffChannels.length == 1 && !isInDepartment)" -->
                  <span
                    v-for="(item,index) in data.treeDepartmentNameArr"
                    :key="index"
                    :style="{ paddingLeft: (index-1) * 30 + 'px' }"
                  ><span
                    v-show="index != 0"
                    style="padding-left: 10px;"
                  /><span v-show="index != 0">►►►</span>{{ item }}<br></span>
                  <span>金幣：{{ data.remainderPropertyCoin }}&nbsp; 鑽石：{{ data.remainderDiamond }}</span>
                  <div style="width:550px;border-bottom: 1px solid #909399;margin-left: -22px;margin-top: 10px;" />
                </template>
              </coin-select>
            </el-form-item>
            <el-form-item
              v-if="!isOutDepartment"
              prop="outStaffChannels"
              class="in_dep"
            >
              <coin-select
                label-name="name"
                sel-val="id"
                :channels="transferObj.outStaffChannels"
                :mul-number="isInDepartment ? (transferObj.inDepChannels.length > 1 ? 1:0) : (transferObj.inStaffChannels.length > 1 ? 1 : 0)"
                :options="outStaffOptions"
                placeholder="請搜索員工"
                :class-name="transferObj.outStaffChannels.length > 1 ? 'custom-select':''"
                @update:channels="transferObj.outStaffChannels = $event"
                @visible-change="selectSeeChannel('outStaff', $event)"
                @filter-method="filterDepStaff('outStaff', $event)"
              >
                <template #default="{ node, data }">
                  <!-- <span> {{ data.name }}({{ data.treeDepartmentName }})-{{data.roleName}}｜金幣：{{ data.remainderPropertyCoin }}&nbsp; 鑽石：{{ data.remainderDiamond }} </span> -->
                  <div>{{ data.name }}-{{ data.roleName }}</div>
                  <span
                    v-for="(item,index) in data.treeDepartmentNameArr"
                    :key="index"
                    :style="{ paddingLeft: index * 40 + 'px' }"
                  ><span style="padding-left: 10px;" /><span>►►►</span>{{ item }}<br></span>
                  <span>金幣：{{ data.remainderPropertyCoin }}&nbsp; 鑽石：{{ data.remainderDiamond }}</span>
                  <div style="width:550px;border-bottom: 1px solid #909399;margin-left: -22px;margin-top: 10px;" />
                </template>
              </coin-select>
            </el-form-item>
          </span>
          <el-form-item
            prop="transferCoin"
            class="coin_dep"
          >
            <!-- <div class="err_txt" v-show="isInDepartment ? (inDepChannels.length > 0 ? false:true) : (inStaffChannels.length > 0 ? false : true)">請選擇轉出人/組別</div> -->
            <div class="coin_num">
              <span>{{ dialogTransCoinType =='coin' ? '金幣' : '鑽石' }}數量：</span>
              <el-input
                v-model="transferObj.transferCoin"
                class="w_150"
                :placeholder="`請輸入${dialogTransCoinType =='coin' ? '金幣' : '鑽石'}數量`"
                @blur="judgeNumErr"
                @input="transferObj.transferCoin = transferObj.transferCoin.replace(/[^\d]/g, '')"
              />
              <span
                v-show="showCoinNUmErr"
                class="err_txt_coin"
              >
                <span class="coin_err">部分組別/員工貨幣量不足，請點擊查看</span>
                <el-tooltip
                  popper-class="ye-vr"
                  placement="top"
                >
                  <div slot="content">
                    <p
                      v-for="(item, index) in numCoinErrTxt"
                      :key="index"
                    >{{ item.name }}<br>｜金幣:{{ item.coinNum }}鑽石:{{ item.diaNum }}</p>
                  </div>
                  <img
                    class="imgTip"
                    src="../../../assets/hovertip.svg"
                    alt=""
                  >
                </el-tooltip>
              </span>
            </div>
          </el-form-item>
        </div>
        <div class="rec_box">
          <span>接收組別/人：</span>
          <span>
            <span class="btns_box">
              <span
                :class="['btns_dep','bor_lef',isInDepartment? 'blu_btn':'']"
                @click="searchDepartment('in')"
              >組別</span>
              <span
                :class="['btns_dep','bor_rig',!isInDepartment? 'blu_btn':'']"
                @click="searchCompanyUser('in')"
              >員工</span>
            </span> 
            <el-form-item
              v-if="isInDepartment"
              prop="inDepChannels"
              class="out_dep"
            >
              <coin-select
                label-name="departmentName"
                sel-val="departmentID"
                :channels="transferObj.inDepChannels"
                :mul-number="isOutDepartment ? (transferObj.outDepChannels.length > 1 ? 1:0) : (transferObj.outStaffChannels.length > 1 ? 1 : 0)"
                :options="inDepOptions"
                placeholder="請搜索組別"
                :class-name="transferObj.inDepChannels.length > 1 ? 'custom-select':''"
                @update:channels="transferObj.inDepChannels = $event"
                @visible-change="selectSeeChannel('inDep', $event)"
                @filter-method="filterDepStaff('inDep', $event)"
              >
                <template #default="{ node, data }">
                  <span
                    v-for="(item,index) in data.treeDepartmentNameArr"
                    :key="index"
                    :style="{ paddingLeft: (index-1) * 40 + 'px' }"
                  ><span
                    v-show="index != 0"
                    style="padding-left: 10px;"
                  /><span v-show="index != 0">►►►</span>{{ item }}<br></span>
                  <span>金幣：{{ data.remainderPropertyCoin }}&nbsp; 鑽石：{{ data.remainderDiamond }}</span>
                  <div style="width:550px;border-bottom: 1px solid #909399;margin-left: -22px;margin-top: 10px;" />
                </template>
              </coin-select>  
            </el-form-item>
            <el-form-item
              v-if="!isInDepartment"
              prop="inStaffChannels"
              class="out_dep"
            >
              <coin-select
                label-name="name"
                sel-val="id"
                :channels="transferObj.inStaffChannels"
                :options="inStaffOptions"
                :mul-number="isOutDepartment ? (transferObj.outDepChannels.length > 1 ? 1:0) : (transferObj.outStaffChannels.length > 1 ? 1 : 0)"
                placeholder="請搜索員工"
                :class-name="transferObj.inStaffChannels.length > 1 ? 'custom-select':''"
                @update:channels="transferObj.inStaffChannels = $event"
                @visible-change="selectSeeChannel('inStaff', $event)"
                @filter-method="filterDepStaff('inStaff', $event)"
              >
                <template #default="{ node, data }">
                  <div>{{ data.name }}-{{ data.roleName }}</div>
                  <span
                    v-for="(item,index) in data.treeDepartmentNameArr"
                    :key="index"
                    :style="{ paddingLeft: index * 40 + 'px' }"
                  ><span style="padding-left: 10px;" /><span>►►►</span>{{ item }}<br></span>
                  <span>金幣：{{ data.remainderPropertyCoin }}&nbsp; 鑽石：{{ data.remainderDiamond }}</span>
                  <div style="width:550px;border-bottom: 1px solid #909399;margin-left: -22px;margin-top: 10px;" />
                </template>   
              </coin-select>       
            </el-form-item>
          </span>
          <!-- <div class="err_txt" v-show="isOutDepartment ? (outDepChannels.length > 0 ? false : true) : (outStaffChannels.length > 0 ? false : true)">請選擇接收人/組別</div> -->
        </div>
      </el-form>
      <span
        slot="footer"
        class="dialog-footer"
      >
        <el-button @click="showDepCoin = false">取 消</el-button>
        <el-button
          type="primary"
          @click="showConCoinDia"
        >下一步</el-button>
      </span>
    </el-dialog>
    <el-dialog
      :close-on-click-modal="false"
      :title="`確認-轉移${dialogTransCoinType =='coin' ? '金幣' : '鑽石'}`"
      :visible.sync="confirmTranCoin"
      width="480px"
      class="assign-dialog transfer_dialog transfer_txtdialog"
      @open="resetScroll"
    >
      <div class="txt_box">
        {{ isOutDepartment ? '組別' : '員工' }}
      </div>
      <div
        ref="depStaoutbox"
        class="depSta_outbox"
      >
        <div
          v-for="(item,index) in confirmOutStrDia"
          :key="index+10"
          class="out_txt"
        >
          <!-- {{ item }} -->
          <!-- 组别-->
          <template v-if="isOutDepartment">
            <span
              v-for="(itemchild,index) in item.treeDepartmentNameArr"
              :key="index"
              :style="{ paddingLeft: (index-1) * 40 + 'px' }"
            ><span
              v-show="index != 0"
              style="padding-left: 10px;"
            /><span v-show="index != 0">►►►</span>{{ itemchild }}<br></span>
            <div style="width:550px;border-bottom: 1px solid #909399;margin-left: -22px;margin-top: 10px;" />
          </template>
          <template v-else>
            <div>{{ item.name }}-{{ item.roleName }}</div>
            <span
              v-for="(itemchild,index) in item.treeDepartmentNameArr"
              :key="index"
              :style="{ paddingLeft: index * 40 + 'px' }"
            ><span style="padding-left: 10px;" /><span>►►►</span>{{ itemchild }}<br></span>
            <div style="width:550px;border-bottom: 1px solid #909399;margin-left: -22px;margin-top: 10px;" />
          </template>
        </div>
      </div>
      <template v-if="confirmOutStrDia.length == 1 && confirmInStrDia.length == 1">
        <div class="count_txt count_txt_btm">
          <span> 轉出</span>
          <span class="red_count">&nbsp;&nbsp;{{ transferObj.transferCoin }}{{ dialogTransCoinType =='coin' ? '金幣' : '鑽石' }}</span>   
          <span>&nbsp;&nbsp;到</span>
        </div>
      </template>
      <template v-else>
        <div class="count_txt count_txt_top">
          <span :class="[transferObj.outDepChannels.length == 1 || transferObj.outStaffChannels.length == 1 ? 'mar_l10':'mar_l20']">{{ (transferObj.outDepChannels.length>1 || transferObj.outStaffChannels.length>1) ? '各' :(transferObj.outDepChannels.length == 1 || transferObj.outStaffChannels.length == 1) ? '一共': '' }}轉出</span>   
          <span class="red_count">{{ parseInt(transferObj.transferCoin)*(isInDepartment ? transferObj.inDepChannels.length : transferObj.inStaffChannels.length) }}{{ dialogTransCoinType =='coin' ? '金幣' : '鑽石' }}</span>   
        </div>           
        <div
          v-if="transferObj.outDepChannels.length || transferObj.outStaffChannels.length"
          class="count_txt count_txt_btm"
        >
          <span class="mar_r10">{{ (transferObj.inDepChannels.length==1 || transferObj.inStaffChannels.length==1) ? '一共' : (transferObj.inDepChannels.length>1 || transferObj.inStaffChannels.length>1) ? '分别' : '' }}接收</span>   
          <span class="red_count">{{ parseInt(transferObj.transferCoin)*(isOutDepartment ? transferObj.outDepChannels.length : transferObj.outStaffChannels.length) }}{{ dialogTransCoinType =='coin' ? '金幣' : '鑽石' }}</span>   
          <span>&nbsp;&nbsp;到</span>   
        </div>  
      </template>
      <div class="txt_box">
        {{ isInDepartment ? '組別' :'員工' }}
      </div>
      <div
        ref="depStaBox"
        class="depSta_box"
      >
        <div
          v-for="(item,index) in confirmInStrDia"
          :key="index"
          class="out_txt"
        >
          <!-- {{ item }} -->
          <template v-if="isInDepartment">
            <span
              v-for="(itemchild,index) in item.treeDepartmentNameArr"
              :key="index"
              :style="{ paddingLeft: (index-1) * 40 + 'px' }"
            ><span
              v-show="index != 0"
              style="padding-left: 10px;"
            /><span v-show="index != 0">►►►</span>{{ itemchild }}<br></span>
            <div style="width:550px;border-bottom: 1px solid #909399;margin-left: -22px;margin-top: 10px;" />
          </template>
          <template v-else>
            <div>{{ item.name }}-{{ item.roleName }}</div>
            <span
              v-for="(itemchild,index) in item.treeDepartmentNameArr"
              :key="index"
              :style="{ paddingLeft: index * 40 + 'px' }"
            ><span style="padding-left: 10px;" /><span>►►►</span>{{ itemchild }}<br></span>
            <div style="width:550px;border-bottom: 1px solid #909399;margin-left: -22px;margin-top: 10px;" />
          </template>
        </div>
      </div> 
      <span
        slot="footer"
        class="dialog-footer"
      >
        <el-button @click="confirmTranCoin = false">取 消</el-button>
        <el-button
          type="primary"
          @click="confirmTransfer"
        >確認轉移</el-button>
      </span>
    </el-dialog>
    <el-dialog
      :close-on-click-modal="false"
      :title="`完成轉移${dialogTransCoinType =='coin' ? '金幣' : '鑽石'}`"
      :visible.sync="acheiveTranCoin"
      width="480px"
      class="assign-dialog transfer_dialog"
      @open="resetScroll"
    >
      <div class="ach_txt">
        已完成轉移{{ dialogTransCoinType =='coin' ? '金幣' : '鑽石' }}程序
      </div>
      <div
        ref="depStaoutbox"
        class="depSta_outbox"
      >
        <div
          v-for="(item,index) in acheiveOutStrDia"
          :key="index+10"
          class="box_txt"
        >
          <!-- <span>{{ item.name }}｜</span> -->
          <template v-if="isOutDepartment">
            <span
              v-for="(itemchild,index) in item.treeDepartmentNameArr"
              :key="index"
              :style="{ paddingLeft: (index-1) * 40 + 'px' }"
            ><span
              v-show="index != 0"
              style="padding-left: 10px;"
            /><span v-show="index != 0">►►►</span>{{ itemchild }}<br></span>
          </template>
          <template v-else>
            <div>{{ item.name }}-{{ item.roleName }}</div>
            <span
              v-for="(itemchild,index) in item.treeDepartmentNameArr"
              :key="index"
              :style="{ paddingLeft: index * 40 + 'px' }"
            ><span style="padding-left: 10px;" /><span>►►►</span>{{ itemchild }}<br></span>
          </template>
          <span>&nbsp;金幣：</span>
          <span :class="{red_num:dialogTransCoinType =='coin'}">
            {{ item.coinNum }}
            <!-- {{
                            dialogTransCoinType === 'coin'
                            ? item.coinNum - (transferObj.transferCoin * (isInDepartment ? Number(transferObj.inDepChannels.length) : Number(transferObj.inStaffChannels.length)))
                            : item.coinNum
                        }} -->
          </span>
          <span>&nbsp;鑽石：</span>
          <span :class="{red_num:dialogTransCoinType =='diamond'}">
            {{ item.diaNum }}
          </span>
          <div style="width:550px;border-bottom: 1px solid #909399;margin-left: -22px;margin-top: 10px;" />
        </div>
      </div>
      <div
        ref="depStaBox"
        class="depSta_box"
      >
        <div
          v-for="(item,index) in acheiveInStrDia"
          :key="index"
          class="box_txt"
        >
          <!-- <span>{{ item.name }}｜</span> -->
          <template v-if="isInDepartment">
            <span
              v-for="(itemchild,index) in item.treeDepartmentNameArr"
              :key="index"
              :style="{ paddingLeft: (index-1) * 40 + 'px' }"
            ><span
              v-show="index != 0"
              style="padding-left: 10px;"
            /><span v-show="index != 0">►►►</span>{{ itemchild }}<br></span>
            <!-- <div style="width:550px;border-bottom: 1px solid #909399;margin-left: -22px;margin-top: 10px;"></div> -->
          </template>
          <template v-else>
            <div>{{ item.name }}-{{ item.roleName }}</div>
            <span
              v-for="(itemchild,index) in item.treeDepartmentNameArr"
              :key="index"
              :style="{ paddingLeft: index * 40 + 'px' }"
            ><span style="padding-left: 10px;" /><span>►►►</span>{{ itemchild }}<br></span>
          </template>
          <span>&nbsp;金幣：</span>
          <span :class="{gre_num:dialogTransCoinType =='coin'}">
            {{ item.coinNum }}
          </span>
          <span>&nbsp;鑽石：</span>
          <span :class="{gre_num:dialogTransCoinType =='diamond'}">
            <!-- {{  dialogTransCoinType =='diamond' ? item.diaNum + Number(transferObj.transferCoin) :item.diaNum}} -->
            {{ item.diaNum }}
          </span>
          <div style="width:550px;border-bottom: 1px solid #909399;margin-left: -22px;margin-top: 10px;" />
        </div>
      </div>
      <span
        slot="footer"
        class="dialog-footer"
      >
        <el-button
          type="primary"
          @click="acheiveTranCoin = false"
        >完成</el-button>
      </span>
    </el-dialog>
    <el-dialog
      :close-on-click-modal="false"
      :title="`完成${operateType === 'assign' || operateType === 'assignAll' ? '分配' : '回收'}${currencyType =='coin' ? '金幣' : '鑽石'}`"
      :visible.sync="acheiveAllTranCoin"
      width="480px"
      class="assign-dialog transfer_dialog"
      @open="resetScroll"
    >
      <div class="ach_txt">
        已完成{{ operateType === 'assign' || operateType === 'assignAll' ? '分配' : '回收' }}{{ currencyType =='coin' ? '金幣' : '鑽石' }}程序
      </div>
      <div
        ref="depStaBox"
        class="depSta_box"
      >
        <div class="box_txt">
          <span>{{ departmentName }}｜</span>
          <span>&nbsp;金幣：</span>
          <span :class="{red_num:currencyType =='coin' && (operateType === 'assign' || operateType === 'assignAll'), gre_num:currencyType =='coin' && (operateType === 'back' || operateType === 'backAll')}">
            {{ remainderPropertyCoin }}
          </span>
          <span>&nbsp;鑽石：</span>
          <span :class="{red_num:currencyType =='diamond' && (operateType === 'assign' || operateType === 'assignAll'),gre_num:currencyType =='diamond' && (operateType === 'back' || operateType === 'backAll')}">
            {{ remainderDiamond }}
          </span>
          <div style="width:550px;border-bottom: 1px solid #909399;margin-left: -22px;margin-top: 10px;" />
        </div>
        <div
          v-for="(item,index) in acheiveAllInStrDia"
          :key="index"
          class="box_txt"
        >
          <!-- <span v-if="currentSelected === 1">{{ item.treeDepartmentName }}｜</span>
                    <span v-else>{{ item.name+'('+item.treeDepartmentName+')'+'-'+item.roleName }}｜</span> -->
          <template v-if="currentSelected === 1">
            <span
              v-for="(itemchild,index) in item.treeDepartmentNameArr"
              :key="index"
              :style="{ paddingLeft: (index-1) * 40 + 'px' }"
            ><span
              v-show="index != 0"
              style="padding-left: 10px;"
            /><span v-show="index != 0">►►►</span>{{ itemchild }}<br></span>
          </template>
          <template v-else>
            <div>{{ item.name }}-{{ item.roleName }}</div>
            <span
              v-for="(itemchild,index) in item.treeDepartmentNameArr"
              :key="index"
              :style="{ paddingLeft: index * 40 + 'px' }"
            ><span style="padding-left: 10px;" /><span>►►►</span>{{ itemchild }}<br></span>
          </template>
          <span>&nbsp;金幣：</span>
          <span :class="{red_num:currencyType =='coin' && (operateType === 'back' || operateType === 'backAll'),gre_num:currencyType =='coin' && (operateType === 'assign' || operateType === 'assignAll')}">
            {{ item.remainderPropertyCoin }}
          </span>
          <span>&nbsp;鑽石：</span>
          <span :class="{red_num:currencyType =='diamond' && (operateType === 'back' || operateType === 'backAll'),gre_num:currencyType =='diamond' && (operateType === 'assign' || operateType === 'assignAll') }">
            {{ item.remainderDiamond }}
          </span>
          <div style="width:550px;border-bottom: 1px solid #909399;margin-left: -22px;margin-top: 10px;" />
        </div>
      </div> 
      <span
        slot="footer"
        class="dialog-footer"
      >
        <el-button
          type="primary"
          @click="acheiveAllTranCoin = false"
        >確認</el-button>
      </span>
    </el-dialog>
    <el-dialog
      :close-on-click-modal="false"
      :title="`確認-${operateType === 'assign' || operateType === 'assignAll' ? '分配' : '回收'}${currencyType=='coin' ? '金幣' :'鑽石'}`"
      :visible.sync="sixbtndia"
      width="480px"
      class="assign-dialog transfer_dialog transfer_txtdialog"
      @open="resetScroll"
    >
      <!-- 首先判断当前是 分配还是回收 -->
      <div v-if="operateType === 'assign' || operateType === 'assignAll'">
        <div class="out_txt">
          {{ departmentName }}
        </div>
        <div style="width:412px;border-bottom: 1px solid #909399;margin-left: -2px;margin-top: 10px;" />
      </div>
      <div
        v-if="operateType === 'back'"
        ref="depStaBox"
        class="depSta_box"
      >
        <div
          v-for="(item,index) in selectedTableTrCopy"
          :key="index+10"
          class="out_txt"
        >
          <!-- {{ currentSelected == 1? item.treeDepartmentName : item.name + '('+ item.treeDepartmentName+')'+'-'+item.roleName}} -->
          <template v-if="currentSelected === 1">
            <span
              v-for="(itemchild,index) in item.treeDepartmentNameArr"
              :key="index"
              :style="{ paddingLeft: (index-1) * 40 + 'px' }"
            ><span
              v-show="index != 0"
              style="padding-left: 10px;"
            /><span v-show="index != 0">►►►</span>{{ itemchild }}<br></span>
          </template>
          <template v-else>
            <div>{{ item.name }}-{{ item.roleName }}</div>
            <span
              v-for="(itemchild,index) in item.treeDepartmentNameArr"
              :key="index"
              :style="{ paddingLeft: index * 40 + 'px' }"
            ><span style="padding-left: 10px;" /><span>►►►</span>{{ itemchild }}<br></span>
          </template>
          <div style="width:550px;border-bottom: 1px solid #909399;margin-left: -22px;margin-top: 10px;" />
        </div>
      </div>
      <div
        v-if="selectedTableTrCopy.length == 1"
        class="count_txt count_txt_btm"
      >
        <span>轉出</span>
        <span
          v-if="currencyType=='coin' "
          class="red_count"
        >&nbsp;&nbsp;{{ operateType === 'back' ? operateForm.coinNum * selectedTableTrCopy.length : operateForm.coinNum }}金幣</span>   
        <span
          v-else
          class="red_count"
        >&nbsp;&nbsp;{{ operateType === 'back' ? diamondOperateForm.diamondNum * selectedTableTrCopy.length : diamondOperateForm.diamondNum }}鑽石</span>   
        <span>&nbsp;&nbsp;到</span>
      </div>
      <template v-if="selectedTableTrCopy.length > 1">
        <div class="count_txt count_txt_top">
          <span :class="[operateType == 'assign'? 'mar_l10':'mar_l20']">{{ operateType === 'assign' || operateType === 'assignAll' ? '一共':'各' }}轉出</span>   
          <span
            v-if="currencyType=='coin'"
            class="red_count"
          >{{ operateType === 'assign' || operateType === 'assignAll' ? operateForm.coinNum * selectedTableTrCopy.length : operateForm.coinNum }}金幣</span>  
          <span
            v-else
            class="red_count"
          >{{ operateType === 'assign' || operateType === 'assignAll' ? diamondOperateForm.diamondNum * selectedTableTrCopy.length : diamondOperateForm.diamondNum }}鑽石</span>  
        </div>           
        <div class="count_txt count_txt_btm">
          <span class="mar_r10">{{ operateType === 'assign' || operateType === 'assignAll' ? '分別' : '一共' }}接收</span>   
          <span
            v-if="currencyType=='coin' "
            class="red_count"
          >{{ operateType === 'back' ? operateForm.coinNum * selectedTableTrCopy.length : operateForm.coinNum }}金幣</span>   
          <span
            v-else
            class="red_count"
          >{{ operateType === 'back' ? diamondOperateForm.diamondNum * selectedTableTrCopy.length : diamondOperateForm.diamondNum }}鑽石</span>   
          <span>&nbsp;&nbsp;到</span>   
        </div>  
      </template>
      <div v-if="operateType === 'back'">
        <div class="out_txt">
          {{ departmentName }}
        </div>
        <div style="width:412px;border-bottom: 1px solid #909399;margin-left: -2px;margin-top: 10px;" />
      </div>
      <div
        v-if="operateType === 'assign' || operateType === 'assignAll'"
        ref="depStaBox"
        class="depSta_box"
      >
        <div
          v-for="(item,index) in selectedTableTrCopy"
          :key="index+10"
          class="out_txt"
        >
          <!-- {{ currentSelected == 1 ? item.treeDepartmentName : item.name + '('+ item.treeDepartmentName+')'+'-'+item.roleName}} -->
          <template v-if="currentSelected === 1">
            <span
              v-for="(itemchild,index) in item.treeDepartmentNameArr"
              :key="index"
              :style="{ paddingLeft: (index-1) * 40 + 'px' }"
            ><span
              v-show="index != 0"
              style="padding-left: 10px;"
            /><span v-show="index != 0">►►►</span>{{ itemchild }}<br></span>
          </template>
          <template v-else>
            <div>{{ item.name }}-{{ item.roleName }}</div>
            <span
              v-for="(itemchild,index) in item.treeDepartmentNameArr"
              :key="index"
              :style="{ paddingLeft: index * 40 + 'px' }"
            ><span style="padding-left: 10px;" /><span>►►►</span>{{ itemchild }}<br></span>
          </template>
          <div style="width:550px;border-bottom: 1px solid #909399;margin-left: -22px;margin-top: 10px;" />
        </div>
      </div>
      <span
        slot="footer"
        class="dialog-footer"
      >
        <el-button @click="sixbtndia = false">取 消</el-button>
        <el-button
          type="primary"
          @click="sendCurrency"
        >確認</el-button>
      </span>
    </el-dialog>

    <!-- 组别金币钻石转移 -->
    <!-- <el-dialog :close-on-click-modal="false" :title="transferType == 'coin' ? '組別-轉移金幣' : '組別-轉移鑽石'" :visible.sync="showDepMoney" width="480px" class="assign-dialog transfer_dialog">
                <div class="dep_box">
                    <span class="txt_coin txt_qi">由：</span>
                    <span class="dep_txt"> {{ selectedTableTr.length ? selectedTableTr[0].departmentName : ''}}</span>
                </div>
                <div class="dep_boxe">
                    <span class="txt_coin">轉移：</span>
                    <span>
                        <el-input :class="['boxe_input']"  v-model="propertyTransCoin" :placeholder="`請輸入${transferType == 'coin' ? '金幣' : '鑽石'}數量`" @blur="tranCoinMax"></el-input>
                    </span>
                    <span class="txt_coin boxe_coin">{{ transferType == 'coin' ? '金幣' : '鑽石' }}</span>
                </div>
                <div v-if="showMoneyCountErr" class="txt_err err_txt">貨幣量不足</div>
                <div v-if="showNumErr" class="txt_err err_txt">請輸入數字</div>
                <div v-if="showErrCoin" class="err_mary err_txt">請輸入{{ transferType == 'coin' ? '金幣' : '鑽石' }}數量</div>
                <div class="dep_boxs">
                    <span class="txt_coin txt_qi">到：</span>
                    <el-cascader 
                        ref="cascader"
                        placeholder="請選擇組別"
                        :options="transferDepOptions"
                        :show-all-levels="false" 
                        clearable 
                        v-model="receiveTransID"
                        popper-class="dep_cascader"
                        @change="handleChanges"
                        :props="{
                            checkStrictly: true,
                            children: 'childNode',
                            value: 'departmentID',
                            label: 'departmentName',
                            disabled: 'disabled'
                        }"
                    ></el-cascader>
                </div>
                <div v-if="showErrId" class="err_mart err_txt">請選擇組別</div>

            <span slot="footer" class="dialog-footer">
                <el-button @click="showDepMoney = false">取 消</el-button>
                <el-button type="primary" :disabled="showMoneyCountErr" @click="confirmDepTransfer">確認</el-button>
            </span>
        </el-dialog> -->
  </div>
</template>
<script>
// import asideBar from "../components/asideBar.vue";
import asideBar from '../../org_manage/components/asideBar.vue';
import CoinSelect from '../components/CoinSelect.vue';
import mixin from '../mixins/index';
import calcAsideHeight from '../mixins/calcAsideHeight';
import { mapState } from 'vuex';
// function debounce(func, delay) {
//     return function () {
//         clearTimeout(func.id);
//         func.id = setTimeout(() => {
//             func.apply(this, arguments);
//         }, delay);
//     };
// }
function debounce(func, delay) {
    let timeoutId;
    return (...args) => {
        clearTimeout(timeoutId);
        timeoutId = setTimeout(() => {
            func(...args);
        }, delay);
    };
}

export default {
    name: 'OraganizationAccount',
    components: {
        asideBar,
        CoinSelect
    },
    mixins: [mixin, calcAsideHeight],
    data() {
        let validateCoinNum = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('請輸入金幣'));
            } else if (value.length > 9) {
                callback(new Error('最大輸入9位數'));
            } else if (!/^[1-9]\d*$/.test(value)) {
                callback(new Error('請輸入數字'));
            } else {
                callback();
            }
        };
        let validateCustomeCoinNum = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('請輸入金幣'));
            } else if (value < 100 || value > 50000 || value % 10 != 0) {
                callback(new Error('最少100金幣，最多50000金幣，且必須為10的倍數'));
            } else {
                callback();
            }
        };
        let validateCustomeDiamondNum = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('請輸入鑽石'));
            } else if (value < 1 || value > 5000) {
                callback(new Error('最少1鑽石，最多5000鑽石'));
            } else {
                callback();
            }
        };
        let validateDiamondNum = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('請輸入鑽石'));
            } else if (value.length > 9) {
                callback(new Error('最大輸入9位數'));
            } else if (!/^[1-9]\d*$/.test(value)) {
                callback(new Error('請輸入數字'));
            } else {
                callback();
            }
        };
        let validateNum = (rule, value, callback) => {
            if (value === '' || value == 0) {
                callback(new Error('請輸入貨幣量'));
            } else if (!/^[1-9]\d*$/.test(value)) {
                this.showCoinNUmErr = false
                callback(new Error('請輸入數字'));
            } else {
                callback();
            }
        };
        return {
            parentDep:{departmentID:0,departmentName:''},
            isExpanded: false,
            sixbtndia:false,
            acheiveAllTranCoin:false,
            acheiveAllInStrDia:[],//全部分配接收组别/员工
            currencyType:'coin',
            staffOptionData:[],
            transferRules:{
                outDepChannels: [{ required: true,  message: '請選擇轉出組別',trigger: 'change' }],
                outStaffChannels: [{ required: true,  message: '請選擇轉出人',trigger: 'change' }],
                inDepChannels: [{ required: true,  message: '請選擇接收組別',trigger: 'change' }],
                inStaffChannels: [{ required: true,  message: '請選擇接收人',trigger: 'change' }],
                transferCoin: [{ required: true, validator: validateNum, trigger: 'blur' }],
            },
            dialogTransCoinType:'coin',
            sourceCoins: [
                {
                    accountID: 0,//员工（非必填）
                    departmentID: 0,//部门（必填）
                }
            ],
            receiveCoins: [
                {
                    accountID: 0,//员工（非必填）
                    departmentID: 0,//部门（必填）
                }
            ],
            checkAll:false,
            transferObj:{
                transferCoin:'',
                outDepChannels:[],
                outStaffChannels:[],
                inDepChannels:[],
                inStaffChannels:[],
            },
            numCoinErrTxt:[],
            showCoinNUmErr:false,
            isOutDepartment:true,
            isInDepartment:false,
            isOutMultiple:false,
            
            outDepOptions:[],
            outStaffOptions:[],
            inStaffOptions:[],
            inDepOptions:[],

            outDepOptionsAll:[],
            outStaffOptionsAll:[],
            inStaffOptionsAll:[],
            inDepOptionsAll:[],
            // depOptionsAll:[],
            // staffOptions:[],
            // staffOptionsAll:[],
            showDepCoin:false,
            confirmTranCoin:false,
            acheiveTranCoin:false,
            transferDepMon:true,
            // showMoneyCountErr:false,
            // receiveTransID:[],
            // propertyTransCoin:'',
            // showDepMoney:false,
            // transferDepOptions:[],
            // showErrCoin: false,
            // showErrId: false,
            // showNumErr:false,
            // transferType:'',
            accountType: false,
            // companyCategory:0,
            isBuyCoin: false, // 禁止购买金币
            isBuyDiamond: false, // 禁止购买砖石
            isUsedDiamond: false, // 是否开启砖石
            isUsedCoin: false,
            // isShowDiamondHistory: false, // 是否展示砖石信息
            // isShowCoinHistory: false, // 是否展示金币信息
            currentSelected: 2, // 1表示組別，2表示員工
            departmentId: 0, //右侧选择组织id
            selectedDepartment: {},
            // departmentName: "", // 当前组织
            remainderPropertyCoin: '', //当前组织金币
            remainderDiamond: '', //當前組別磚石
            coinNumMin: '',
            coinNumMax: '',
            diamondNumMin: '',
            diamondNumMax: '',
            // organizationName: "",
            // treeData: [],
            // tableData: [], // 当前组织表格数据
            // departmentPageIndex: 1,
            // departmentPageCount: 5,
            // departmentTotal: 0,
            selectedTableTr: [], // 选中的表格
            selectedTableTrCopy:[],
            // 购买金币
            buyCoinDialogVisible: false, //購買金幣彈框
            submittingCoin: false,
            coinNumOptions: [],
            buyCoinForm: {
                buyCoinNumId: '',
                buyCoinNum: ''
            },
            buyCoinRules: {
                buyCoinNumId: [{ required: true, message: '未選擇購買金幣', trigger: 'change' }],
                buyCoinNum: [{ validator: validateCustomeCoinNum, trigger: 'change' }]
            },
            //购买砖石
            buyDiamondDialogVisible: false,
            submittingDiamond: false,
            diamondNumOptions: [],
            buyDiamondForm: {
                buyNumId: '',
                buyNum: ''
            },
            buyDiamondRules: {
                buyNumId: [{ required: true, message: '未選擇購買鑽石', trigger: 'change' }],
                buyNum: [{ validator: validateCustomeDiamondNum, trigger: 'change' }]
            },
            customDiamondInput: () => {},
            // 分配与回收金币 分配全部操作
            operateForm: {
                coinNum: ''
            }, //金幣數量
            operateType: '', //操作類型
            operateRules: {
                coinNum: [{ validator: validateCoinNum, trigger: 'change' }],
                backAllMethod: [
                    {
                        validator: (rule, value, callback) => {
                            if (value === '') {
                                callback(new Error('請選擇回收方式'));
                            } else {
                                callback();
                            }
                        },
                        trigger: 'change'
                    }
                ],
                backAllCoinNum: [{ validator: validateCoinNum, trigger: 'change' }]
            },

            // assignCoinNum: "", //分配金币数量
            coinOperateDialogVisible: false, // 分配金幣彈框
            // backCoinDialogVisible: false, //回收金幣
            // backCoinNum: "",
            backAllForm: {
                backAllCoinNum: '', //回收全部的金币数量
                backAllMethod: '' //回收全部的方式
            },
            // assignAllCoinNum: "",
            backAllCoinDialogVisible: false, // 回收全部
            // assignAllCoinDialogVisible: false,
            /* 砖石操作 */
            diamondOperateForm: {
                diamondNum: ''
            },
            diamondOperateRules: {
                diamondNum: [{ validator: validateDiamondNum, trigger: 'change' }],
                backAllMethod: [
                    {
                        validator: (rule, value, callback) => {
                            if (value === '') {
                                callback(new Error('請選擇回收方式'));
                            } else {
                                callback();
                            }
                        },
                        trigger: 'change'
                    }
                ],
                backAllDiamondNum: [{ validator: validateDiamondNum, trigger: 'change' }]
            },
            diamondOperateDialogVisible: false, // 分配砖石彈框
            diamondBackAllForm: {
                backAllDiamondNum: '', //回收全部的金币数量
                backAllMethod: '' //回收全部的方式
            },
            backAllDiamondDialogVisible: false, // 回收全部
            //  員工相關數據
            departmentOptions: [],
            staffName: '',
            staffCoinNumMin: '',
            staffCoinNumMax: '',
            staffDiamondNumMin: '',
            staffDiamondNumMax: '',
            // staffTableData: [],
            // staffPageIndex: 1,
            // staffPageCount: 5,
            // staffTotal: 0,
            steps: [
                {
                    element: '.btn-guide',
                    closeBtnText: '關閉',
                    popover: {
                        className: !this.$route.params.initiativeGuide ? 'first-guidance' : '',
                        title: '支援按組別／員工分配及回收金幣'
                    },
                    onNext: () => {
                        this.$router.push({
                            name: this.pub.routeNameLists.PersonalCenter,
                            params: {
                                guide: 1,
                                initiativeGuide: this.$route.params.initiativeGuide
                            }
                        });
                    }
                }
                // 由于类名问题导致的
                // {
                //     element: '.notall-guides',
                //     closeBtnText: '關閉',
                //     popover: {
                //         className: !this.$route.params.initiativeGuide ? 'first-guidance' : '',
                //         title: '1、分配金幣 <br /> 2、支援向個別／多個賬戶分配及回收金幣'
                //     }
                //     }
                // },
                //     element: '.all-guide',
                //     closeBtnText: '關閉',
                //     title: '1、可以同時 <br /> 全部分配／回收賬戶的金幣',
                //     onNext: () => {
                //         this.$router.push({
                //             params: {
                //                 guide: 1,
                //                 initiativeGuide: this.$route.params.initiativeGuide
                //             }
                //         });
                //     }
                // }
            ],
            debouceTiemoutId: null,
            customeMoney: 0,
            customDiamondMoney: 0,
            cascaderVisible: false,
            confirmInStrDia:[],
            confirmOutStrDia:[],
            acheiveInStrDia:[
                {
                    treeDepartmentNameArr:[],
                    roleName:'',
                    name:'',
                    coinNum:'',
                    DiaNum:'',
                }
            ],
            acheiveOutStrDia:[
                {
                    treeDepartmentNameArr:[],
                    roleName:'',
                    name:'',
                    coinNum:'',
                    DiaNum:'',
                }
            ],
        };
    },
    watch: {
        '$route'(to, from) {
            // 路由变化时的处理逻辑
            this.currentSelected = 2
            this.parentId = this.userInfo.departmentID 
            this.departmentId = this.parentId;
            this.getDepartmentById(this.parentId);
            this.parentDep={
                departmentID:'',
                departmentName: ''
            }
            this.$refs.staffTable.clearSelection()
            this.selectedTableTr = [];
        },
        currentSelected(val) {
            this.selectedTableTr = [];
            let params = this.getSearchParams();
            if (val === 1) {
                this.departmentPageCount = this.pub.getPageSize(this.userInfo.accountID, 'mcoinInPageCount') || 10;
                this.getDepartments(params);
            } else {
                this.staffPageCount = this.pub.getPageSize(this.userInfo.accountID, 'pcoinInPageCount') || 10;
                this.searchCompanyUserInfo(params);
            }
        }
    },
    async created() {
        if(this.$route.name == 'Coin_CoinManage' || this.$route.name == 'Coin_Record'){
            this.showExpanded = true;
        }else{
            this.showExpanded = false;
        }
        this.parentId = this.userInfo.departmentID || (await this.getUserInfo());
        await this.getDepartmentsTree(); //获取侧边栏树形数据
        if(this.$route.query.depId){
            // 公司账户管理员跳转进入时候 路由中的父id 为左侧树状图选中id 。 
            // 非公司账户或非管理员身份，depId为树状图选中id
            this.departmentId = this.$route.query.parId && this.$route.query.parId != 0 ? this.$route.query.parId : this.$route.query.depId
            if(this.$route.query.accId == 0){
                this.currentSelected = 1
            }else{
                this.currentSelected = 2
            }
            this.getDepartmentById(this.departmentId)       
        }else{
            this.departmentId = this.parentId; //默认第一个选中
            this.getDepartmentById(this.parentId);
        }
        // this.getDepartments();
        this.getCompanyCofig();
        if (this.currentSelected === 1) {
            this.departmentPageCount = this.pub.getPageSize(this.userInfo.accountID, 'mcoinInPageCount') || 10;
            await this.getDepartments();
            // 公司账户管理员 从业务设定跳转进入该页面
            if(this.$route.query.depId && this.$route.query.accId == 0){
                this.findAndSelectDep(this.$route.query.depId)
            }
        } else {
            this.staffPageCount = this.pub.getPageSize(this.userInfo.accountID, 'pcoinInPageCount') || 10;
            let data={"status":"normal"}
            this.staffStatus="normal"
            await this.searchCompanyUserInfo(data);
            if(this.$route.query.accId){
                this.findAndSelectAccount(this.$route.query.accId);
            }

        }
        this.customDiamondInput = debounce(this.getCustomDiamond, 1000);
        this.staffOptionsObtain()
        this.searchCompanyUser('out')
        // true代表为公司账户
        this.searchCompanyUser('in')
        this.searchDepartment('out')
    },
    mounted() {
        // 新手导航
        if (this.$route.params.guide) {
            setTimeout(() => {
                this.pub.guide(this.Driver, this.steps);
            }, 500);
        }
        this.isInDepartment = this.currentSelected == 1 ? true : false
    },
    methods: {
        isApiSelectedRow(row) {
            return this.$route.query.roleName && this.apiSelectedRow && this.apiSelectedRow.departmentID  === row.departmentID;
        },
        async findAndSelectDep(depId) {
            if(!this.$route.query.parId || this.$route.query.parId ==0 ){return}
            let pageIndex = 1;
            const totalPages = Math.ceil(this.departmentTotal / this.departmentPageCount);
            while (pageIndex <= totalPages) {
                const res = await this.axios.post(
                    this.pub.getApi().GetDepartments,
                    {
                        parentID: this.$route.query.parId,
                        pageIndex: pageIndex,
                        pageCount: this.departmentPageCount,
                    },
                );
                const { code, result } = res.data;
                if (code === 0) {
                    const matchRow = result.data.find(item => {
                        return item.departmentID == depId;
                    });
                    if (matchRow) {
                        // 命中目标页，更新当前页数据并选中
                        this.tableData = result.data;
                        this.departmentPageIndex = pageIndex;
                        this.departmentTotal = result.count;
                        this.$nextTick(() => {
                            this.$refs.depTable.toggleRowSelection(matchRow, true);
                            this.apiSelectedRow = matchRow;
                            this.handleSelectionChange([matchRow]);
                        });
                        break;
                    }
                }
                pageIndex++;
            }
        },
        // 业务设定跳转 分页数据默认选中项 跳转到具体页
        async findAndSelectAccount(accId) {
            let pageIndex = 1;
            const totalPages = Math.ceil(this.staffTotal / this.staffPageCount);
            while (pageIndex <= totalPages) {
                const res = await this.axios.post(
                    this.pub.getApi().SearchCompanyUserInfo,
                    {
                        departmentID: this.departmentId,
                        pageIndex: pageIndex,
                        pageCount: this.staffPageCount,
                        coinMananger: this.$route.path === '/coin/index',
                        // status:'normal',
                    }
                );
                const { code, result } = res.data;
                if (code === 0) {
                    const matchRow = result.data.find(item => item.accountID == accId);
                    if (matchRow) {
                        // 命中目标页，更新当前页数据并选中
                        this.staffStatus = 0
                        this.staffTableData = result.data;
                        this.staffPageIndex = pageIndex;
                        this.staffTotal = result.count;
                        this.$nextTick(() => {
                            this.$refs.staffTable.toggleRowSelection(matchRow, true);
                            this.handleSelectionChange([matchRow]);
                        });
                        break;
                    }
                }
                pageIndex++;
            }
        },
        toUpLevel(){
            this.departmentId = this.parentDep.departmentID;
            this.selectedDepartment = this.parentDep;
            this.$refs.asideBar.setTreeCurrentNode(this.departmentId);
            this.getDepartmentById(this.departmentId,'parentDep');
            if (this.currentSelected === 1) {
                this.departmentPageIndex = 1;
                this.search();
            } else {
                this.staffPageIndex = 1;
                this.staffSearch();
            }
        },
        resetScroll(){
            this.$nextTick(()=>{
                this.$refs.depStaBox.scrollTop = 0;
                this.$refs.depStaoutbox.scrollTop = 0;
            })
        },
        judgeNumErr(){
            this.showCoinNUmErr = false
            if(this.isInDepartment){
                this.transformDep(this.transferObj.inDepChannels,'in','blurNum')
            }else{
                this.transformStaff(this.transferObj.inStaffChannels,'in','blurNum')
            }
            // 判断是否有转出组别存在货币量不足的情况
            if(this.isOutDepartment){
                this.transformDep(this.transferObj.outDepChannels,'out','blurNum')
            }else{
                this.transformStaff(this.transferObj.outStaffChannels,'out','blurNum')
            }
        },
        changeSelected(type){
           this.currentSelected = type == 'dep' ? 1 : 2
           this.isInDepartment = this.currentSelected == 1 ? true : false
        },
        async openTransferDia(){
            this.showCoinNUmErr = false

            // 避免打开弹框多选出现校验问题
            this.$nextTick(()=>{
                this.$refs.transferForm.clearValidate()
            })
            await this.sycDepStaffData()
        },
        confirmTransfer(){
            this.receiveCoins=[]
            this.sorceCoins=[]
            if(this.isInDepartment){
                if(this.transferObj.inDepChannels.length){
                    this.receiveCoins = this.transferObj.inDepChannels.map(departmentID => ({
                        accountID: 0,
                        departmentID: parseInt(departmentID)
                    }));
                }

            }else{
                this.receiveCoins = this.transferObj.inStaffChannels.map(item => {
                    let [accountID, departmentID] = item.split('_');
                    return {
                        accountID: parseInt(accountID),
                        departmentID: parseInt(departmentID)
                    };
                });
            }
            // 接收组别/人
            if(this.isOutDepartment){
                if(this.transferObj.outDepChannels.length){
                    this.sorceCoins = this.transferObj.outDepChannels.map(departmentID => ({
                        accountID: 0,
                        departmentID: parseInt(departmentID)
                    }));
                }

            }else{
                this.sorceCoins = this.transferObj.outStaffChannels.map(item => {
                    let [accountID, departmentID] = item.split('_');
                    return {
                        accountID: parseInt(accountID),
                        departmentID: parseInt(departmentID)
                    };
                });
            }
            // 转移金币接口处理
            this.confirmTranCoin = false
            this.transferCoinMeth(this.sorceCoins,this.receiveCoins)
        },
        async transferCoinMeth(){
            // let data = {
            //     sendCoins: [],
            //     sendCoinType: sendCoinType
            // };
            let data = {
                SendCoins:[], 
                sourceCoins: this.sorceCoins,
                receiveCoins: this.receiveCoins,
                PropertyCoin:this.transferObj.transferCoin,
                sendCoinType:'CustomChoice'
            }
            let res = {}
            if(this.dialogTransCoinType =='coin'){
                res = await this.axios.post(this.pub.getApi().SendCoin, data);
            }else{
                res = await this.axios.post(this.pub.getApi().SendDiamond, data);
            }
            let coinType= this.dialogTransCoinType =='coin' ? '金幣' :'鑽石'
            let { code, message, result } = res.data;
            if (code === 0) {
                this.getPropertyCoin();
                let params = this.getSearchParams();
                // 转移完成后 更新接口数据 金币余额更新
                await this.staffOptionsObtain()
                await this.searchCompanyUser('out',"notClear")
                // true代表为公司账户
                await this.searchCompanyUser('in',"notClear")
                await this.searchDepartment('out',"notClear")
                await this.searchDepartment('in',"notClear")
                this.searchCompanyUserInfo(params);
                if (this.currentSelected == 1) {
                    this.getDepartments(params);
                }
                this.acheiveInStrDia = []
                this.acheiveOutStrDia = []
                if(this.isInDepartment){
                    this.transformDep(this.transferObj.inDepChannels,'in','achieve')
                }else{
                    this.transformStaff(this.transferObj.inStaffChannels,'in','achieve')
                }
                // 判断是否有转出组别存在货币量不足的情况
                if(this.isOutDepartment){
                    this.transformDep(this.transferObj.outDepChannels,'out','achieve')
                }else{
                    this.transformStaff(this.transferObj.outStaffChannels,'out','achieve')
                }
                this.acheiveTranCoin = true

            } else if (code === 2003) {
                this.$message({
                    message: `賬戶${coinType}餘額不足,分配失敗`,
                    type: 'error',
                    showClose: true
                });
            } else if (code === 2004) {
                this.$message({
                    message: `回收賬戶的${coinType}餘額不足,回收失敗`,
                    type: 'error',
                    showClose: true
                });
            } else {
                this.$message({
                    message,
                    type: 'error',
                    showClose: true
                });
            }

        },
        showConCoinDia(){
            // 校验是否有填写数字
            this.$refs.transferForm.validate(async (valid,errobj) => {
                if(valid){
                    this.showCoinNUmErr = false
                    // 将对应数据转换为文字
                    this.confirmInStrDia = []
                    this.confirmOutStrDia = []
                    this.acheiveInStrDia = []
                    this.acheiveOutStrDia = []
                    if(this.isInDepartment){
                        this.transformDep(this.transferObj.inDepChannels,'in','confirm')
                    }else{
                        this.transformStaff(this.transferObj.inStaffChannels,'in','confirm')
                    }
                    // 判断是否有转出组别存在货币量不足的情况
                    if(this.isOutDepartment){
                        this.transformDep(this.transferObj.outDepChannels,'out','confirm')
                    }else{
                        this.transformStaff(this.transferObj.outStaffChannels,'out','confirm')
                    }
                    if(this.showCoinNUmErr) {return false}
                    this.showDepCoin = false
                    this.confirmTranCoin = true
                }else{
                    // this.error('樓盤資料不完整，請根據提示補充資料');
                    return false;
                }
                
            })
            
        },
        transformStaff(obj,type,dialogType){
            let strArr = ''
            let achStrArr = ''
            let staffOptionsAll = ''
            if(type == 'in'){
                strArr = 'confirmInStrDia'
                achStrArr = 'acheiveInStrDia'
                staffOptionsAll = 'inStaffOptionsAll'
            }else{
                strArr= 'confirmOutStrDia'
                achStrArr = 'acheiveOutStrDia'
                staffOptionsAll = 'outStaffOptionsAll'
            }
            this.numCoinErrTxt = []
            let number = this.isInDepartment ? this.transferObj.inDepChannels.length : this.transferObj.inStaffChannels.length
            for (let item of obj) {
                // 拆分字符串为 accountID 和 departmentID
                let [accIdStr, depIdStr] = item.split('_');
                let accId = parseInt(accIdStr);
                let depId = parseInt(depIdStr);
                // 在 staffArr 中查找完全匹配的项
                let found = this[staffOptionsAll].find(objSaff =>{
                    return  objSaff.accountID === accId && objSaff.departmentID === depId
                });
                if (found) {
                    // 如果找到，拼接字符串并推入结果数组
                    // let resultStr = `${found.name}(${found.treeDepartmentName})-${found.roleName}`;
                    let resultStr = `${found.name}(${found.treeDepartmentName})-${found.roleName}`;
                    if(dialogType == 'confirm'){
                        // this[strArr].push(resultStr);
                        this[strArr].push({treeDepartmentNameArr:found.treeDepartmentNameArr,name:found.name,roleName:found.roleName});
                    }else if(dialogType == 'achieve'){
                        this[achStrArr].push({treeDepartmentNameArr:found.treeDepartmentNameArr,name:found.name,roleName:found.roleName,coinNum:found.remainderPropertyCoin,diaNum:found.remainderDiamond});
                        // this[achStrArr].push({name:resultStr,coinNum:found.remainderPropertyCoin,diaNum:found.remainderDiamond});
                    }
                    if(dialogType == 'confirm' || dialogType == 'blurNum'){
                        if(!this.isOutDepartment && type == 'out' &&((this.dialogTransCoinType =='coin' && found.remainderPropertyCoin < this.transferObj.transferCoin*number)||(this.dialogTransCoinType =='diamond' && found.remainderDiamond < this.transferObj.transferCoin*number))){
                            this.numCoinErrTxt.push({name:resultStr,coinNum:found.remainderPropertyCoin,diaNum:found.remainderDiamond})
                            this.showCoinNUmErr = true
                        }
                    }
                } 
            }
        },
        transformDep(obj,type,dialogType){
            let strArr = ''
            let achStrArr = ''
            let depOptionsAll = ''
            if(type == 'in'){
                strArr = 'confirmInStrDia'
                achStrArr = 'acheiveInStrDia'
                depOptionsAll = 'inDepOptionsAll'
            }else{
                strArr= 'confirmOutStrDia'
                achStrArr = 'acheiveOutStrDia'
                depOptionsAll = 'outDepOptionsAll'
            }
            this.numCoinErrTxt = []
            let number = this.isInDepartment ? this.transferObj.inDepChannels.length : this.transferObj.inStaffChannels.length
            for (let item of obj) {
                // 在 staffArr 中查找完全匹配的项
                let found = this[depOptionsAll].find(objDep => objDep.departmentID === item);
                if (found) {
                    // 如果找到，拼接字符串并推入结果数组
                    let resultStr = `${found.treeDepartmentName}`;
                    if(dialogType == 'confirm'){
                        this[strArr].push({treeDepartmentNameArr:found.treeDepartmentNameArr});
                        // this[strArr].push(resultStr);
                    }else if(dialogType == 'achieve'){
                        this[achStrArr].push({treeDepartmentNameArr:found.treeDepartmentNameArr,name:found.name,roleName:found.roleName,coinNum:found.remainderPropertyCoin,diaNum:found.remainderDiamond});
                        // this[achStrArr].push({name:resultStr,coinNum:found.remainderPropertyCoin,diaNum:found.remainderDiamond});
                    }
                    if(dialogType == 'confirm' || dialogType == 'blurNum'){
                        if(this.isOutDepartment && type == 'out' &&( (this.dialogTransCoinType =='coin' && found.remainderPropertyCoin < this.transferObj.transferCoin*number )||(this.dialogTransCoinType =='diamond' && found.remainderDiamond < this.transferObj.transferCoin*number))){
                            this.numCoinErrTxt.push({name:resultStr,coinNum:found.remainderPropertyCoin,diaNum:found.remainderDiamond})
                            this.showCoinNUmErr = true
                        }
                    }
                } 
            }
        },
        async showTranCoinDia(type){
            this.dialogTransCoinType = type
            this.showDepCoin=true
            this.transferObj.transferCoin = ''
            this.transferObj.outDepChannels = []
            this.transferObj.outStaffChannels = []
            this.transferObj.inDepChannels = []
            this.transferObj.inStaffChannels = []
            // 初次弹框转出默认组别 转入默认员工
            this.isOutDepartment = true
            // this.isInDepartment = false
            if (this.selectedTableTr && this.selectedTableTr.length) {
                // 下方table存在选中项时 根据当前页面所在tab，判断转出默认勾选
                this.isOutDepartment = this.currentSelected == 1 ? true : false
                if(this.isOutDepartment){
                    for (let i = 0; i < this.selectedTableTr.length; i++) {
                        this.transferObj.outDepChannels.push(this.selectedTableTr[i].departmentID)
                    }
                    // if(this.selectedTableTr.length > 1){
                    //     this.$nextTick(() => {
                    //         const domNodeList = document.querySelectorAll('.custom-select .el-select__tags .el-tag .el-select__tags-text')
                    //         if (domNodeList.length > 1) {
                    //             const domNode = document.querySelector('.custom-select .el-select__tags .el-tag:last-child .el-select__tags-text')
                    //             domNode.innerText = `全部顯示+ ${this.transferObj.outDepChannels.length}`
                    //         }
                    //     })
                    // }
                }else{
                    for (let i = 0; i < this.selectedTableTr.length; i++) {
                        let str= this.selectedTableTr[i].accountID+'_'+this.selectedTableTr[i].departmentID
                        this.transferObj.outStaffChannels.push(str)
                    }  
                    // if(this.selectedTableTr.length > 1){
                    //     this.$nextTick(() => {
                    //         const domNodeList = document.querySelectorAll('.custom-select .el-select__tags .el-tag .el-select__tags-text')
                    //         if (domNodeList.length > 1) {
                    //             const domNode = document.querySelector('.custom-select .el-select__tags .el-tag:last-child .el-select__tags-text')
                    //             domNode.innerText = `全部顯示+ ${this.transferObj.outStaffChannels.length}`
                    //         }
                    //     })
                    // }
                }
                // this.handleChild()
            }else{
                this.isInDepartment = this.currentSelected == 1 ? true : false
            }
        },
        // 更新员工 组别数据
        sycDepStaffData(){
            // 防止操作过金币转移，但金币钻石仍为老数据，在此重新获取最新数据
            return new Promise(async (resolve, reject) => {
                let optionStaffAll =  this.staffOptionData.map(item => ({
                    ...item,
                    id: `${item.accountID}_${item.departmentID}` 
                }));
                this.inStaffOptions = JSON.parse(JSON.stringify(optionStaffAll));
                this.inStaffOptionsAll = JSON.parse(JSON.stringify(optionStaffAll));
                this.outStaffOptions = JSON.parse(JSON.stringify(optionStaffAll));
                this.outStaffOptionsAll = JSON.parse(JSON.stringify(optionStaffAll));
                let res = await this.axios.post(this.pub.getApi().SearchAllDepartmentsByParentID, {
                    pageIndex:1,
                    pageCount:100,
                    isSelfDepartment:true,
                    departmentName:''
                });
                this.inDepOptions = JSON.parse(JSON.stringify(res.data.result.data ));
                this.inDepOptionsAll = JSON.parse(JSON.stringify(res.data.result.data));
                this.outDepOptions = JSON.parse(JSON.stringify(res.data.result.data));
                this.outDepOptionsAll = JSON.parse(JSON.stringify(res.data.result.data));
                resolve()
            })
            
        },
        // 获取员工下拉列表
        async searchCompanyUser(type,clearType){
            return new Promise(async (resolve, reject) => { 
                let optionStaffAll =  this.staffOptionData.map(item => ({
                    ...item,
                    id: `${item.accountID}_${item.departmentID}` 
                }));
                // 根据转出转入员工 置空数据
                if(type == 'in'){
                    this.inStaffOptions = JSON.parse(JSON.stringify(optionStaffAll));
                    this.inStaffOptionsAll = JSON.parse(JSON.stringify(optionStaffAll));
                    if(clearType != 'notClear'){
                        this.transferObj.inStaffChannels = []
                        this.transferObj.inDepChannels = []
                        this.isInDepartment = false
                    }
                }else{
                    this.outStaffOptions = JSON.parse(JSON.stringify(optionStaffAll));
                    this.outStaffOptionsAll = JSON.parse(JSON.stringify(optionStaffAll));
                    if(clearType != 'notClear'){
                        this.transferObj.outStaffChannels = []
                        this.transferObj.outDepChannels = []
                        this.isOutDepartment = false
                    }
                }
                resolve()
            })
        },
        async searchDepartment(type,clearType){
            return new Promise(async (resolve, reject) => { 
                let res = await this.axios.post(this.pub.getApi().SearchAllDepartmentsByParentID, {
                    pageIndex:1,
                    pageCount:100,
                    departmentName:'',
                    isSelfDepartment:true,
                });
                if(type == 'in'){
                    this.inDepOptions = JSON.parse(JSON.stringify(res.data.result.data ));
                    this.inDepOptionsAll = JSON.parse(JSON.stringify(res.data.result.data));
                    if(clearType != 'notClear'){
                        this.transferObj.inDepChannels = []
                        this.transferObj.inStaffChannels = []
                        this.isInDepartment = true
                    }
                }else{
                    this.outDepOptions = JSON.parse(JSON.stringify(res.data.result.data));
                    this.outDepOptionsAll = JSON.parse(JSON.stringify(res.data.result.data));
                    if(clearType != 'notClear'){
                        this.showCoinNUmErr = false
                        this.transferObj.outDepChannels = []
                        this.transferObj.outStaffChannels = []
                        this.isOutDepartment = true
                    }
                }
                resolve()
            })
        },
        // handleSelect(value){
        //     let filterArray = []
        //     let arr = value || []
        //     filterArray = this.depOptions.filter(function(item) {
        //         return arr.indexOf(item.departmentID) != -1
        //     });
        //     console.log("选择了某项")
        //     return
        // },
        selectSeeChannel(type,e){
            // inStaff inDep选中的数据   outStaff outDep中不能出现
            // if(e == true){
                // 当第一次打开下拉框，若对应数据存在已被选中可能，将其筛选掉
                if(type == 'inStaff' ){
                    let staffArrSet = new Set(this.transferObj.outStaffChannels.map(str => {
                        let [accId, depId] = str.split('_');
                        return `${accId}_${depId}`;
                    }));
                    if(this.transferObj.outStaffChannels.length){
                        this.inStaffOptions = this.inStaffOptionsAll.filter(function(item) {
                            let key = `${item.accountID}_${item.departmentID}`;
                            return !staffArrSet.has(key);
                            // return this.transferObj.outStaffChannels.indexOf(item.accountID) == -1
                        },this);
                    }else{
                        this.inStaffOptions = JSON.parse(JSON.stringify(this.inStaffOptionsAll));
                    }
                }else if(type == 'inDep'){
                    if(this.transferObj.outDepChannels.length){
                        this.inDepOptions = this.inDepOptionsAll.filter(function(item) {
                            return this.transferObj.outDepChannels.indexOf(item.departmentID) == -1
                        },this);
                    }else{
                        this.inDepOptions = JSON.parse(JSON.stringify(this.inDepOptionsAll));
                    }

                }else if(type == 'outStaff'){
                    this.showCoinNUmErr = false
                    let staffArrSet = new Set(this.transferObj.inStaffChannels.map(str => {
                        let [accId, depId] = str.split('_');
                        return `${accId}_${depId}`;
                    }));
                    if(this.transferObj.inStaffChannels.length){
                        this.outStaffOptions = this.outStaffOptionsAll.filter(function(item) {
                            let key = `${item.accountID}_${item.departmentID}`;
                            return !staffArrSet.has(key);
                            // return this.transferObj.inStaffChannels.indexOf(item.accountID) == -1
                        },this);
                    }else{
                        this.outStaffOptions = JSON.parse(JSON.stringify(this.outStaffOptionsAll));
                    }
                }else if(type == 'outDep' ){
                    this.showCoinNUmErr = false
                    if(this.transferObj.inDepChannels.length){
                        this.outDepOptions = this.outDepOptionsAll.filter(function(item) {
                            return this.transferObj.inDepChannels.indexOf(item.departmentID) == -1
                        },this);
                    }else{
                        this.outDepOptions = JSON.parse(JSON.stringify(this.outDepOptionsAll));
                    }
                }
            // }
            // if(e == false){
            //     // 当搜索数据选中后关闭下拉框，再次打开后，为全部数据
            //     if(type == 'inStaff'){
            //         this.inStaffOptions = JSON.parse(JSON.stringify(this.inStaffOptionsAll));
            //     }else if(type == 'inDep'){
            //         this.inDepOptions = JSON.parse(JSON.stringify(this.inDepOptionsAll));
            //     }else if(type == 'outStaff'){
            //         this.outStaffOptions = JSON.parse(JSON.stringify(this.outStaffOptionsAll));
            //     }else{
            //         this.outDepOptions = JSON.parse(JSON.stringify(this.outDepOptionsAll));
            //     }
            // }
            return
        },
        // 获取所有员工最新的数据
        async staffOptionsObtain(){
            return new Promise(async (resolve, reject) => { 
                // 查询员工
                let res = await this.axios.post(this.pub.getApi().SearchCompanyUserInfo,{
                    departmentID: '',
                    pageIndex: 1,
                    pageCount: 100,
                    coinMananger:true,
                    isCoinManangerCustomChoice:true,
                    searchName:'',
                    //status: "normal"
                });
                this.staffOptionData = res.data.result.data;
                resolve()
            })
        },
        filterDepStaff(type,val){
            clearTimeout(this.timer);
            this.timer = setTimeout(async() => {
                if(type == 'inDep' || type == 'outDep'){
                    let res = await this.axios.post(this.pub.getApi().SearchAllDepartmentsByParentID, {
                        pageIndex:1,
                        pageCount:100,
                        departmentName:val,
                        isSelfDepartment:true,
                    });
                    if(type == 'inDep'){
                        this.inDepOptions = JSON.parse(JSON.stringify(res.data.result.data));
                    }else{
                        this.outDepOptions = JSON.parse(JSON.stringify(res.data.result.data));
                    }
                }else{
                    let res = await this.axios.post(this.pub.getApi().SearchCompanyUserInfo,{
                        departmentID: '',
                        pageIndex: 1,
                        pageCount: 100,
                        coinMananger:true,
                        isCoinManangerCustomChoice:true,
                        status: "normal",
                        searchName:val,
                    });
                    let staffOptionDataAll =  res.data.result.data.map(item => ({
                        ...item,
                        id: `${item.accountID}_${item.departmentID}` 
                    }));
                    if(type == 'inStaff'){
                        this.inStaffOptions = JSON.parse(JSON.stringify(staffOptionDataAll));
                    }else if(type == 'outStaff'){
                        this.outStaffOptions = JSON.parse(JSON.stringify(staffOptionDataAll));
                    }
                }
            }, 300); 
            return
        },
        // handleChanges(){
        //     var cascaderNodes = this.$refs.cascader.getCheckedNodes();
        //     if (cascaderNodes.length > 0 && cascaderNodes[0].children.length === 0) {
        //         this.$refs.cascader.dropDownVisible = false;
        //     }
        // },
        /* 多选框  选择*/
        canSelectRow(row, index) {
            if(this.roleTransition[row.roleID]){
                return this.roleTransition[row.roleID].trim() == '營業助理' ? false : true;
            }
        },
        // 获取公司配置
        getCompanyCofig() {
            this.axios.get(this.pub.getApi().GetCompanyCofig).then(res => {
                // console.log(res,'配置');
                if (res.data.code === 0 && res.data.result) {
                    // 1 中原，2 利嘉阁 3 其他公司
                    this.isBuyCoin = res.data.result.isBuyCoin;
                    this.isBuyDiamond = res.data.result.isBuyDiamond;
                    this.isUsedCoin = res.data.result.isUsedCoin;
                    this.isUsedDiamond = res.data.result.isUsedDiamond;
                    // this.isShowDiamondHistory = res.data.result.isShowDiamondHistory;
                    // this.isShowCoinHistory = res.data.result.isShowCoinHistory;
                    this.accountType = res.data.result.accountType;
                }
                if (this.accountType && (this.userInfo.roleID == 1 || this.userInfo.roleID == 2)) {
                    // 将总行管理员和分行管理员进行删除 公司账户时
                    // console.log('this.optionsssss', this.roleOptions);
                    if (this.roleOptions) {
                        this.roleOptions = this.roleOptions.filter(function (item) {
                            return item.roleID !== 1 && item.roleID !== 2;
                        });
                    }
                }
            });
        },
        // 选择组织
        choseOrganization(data) {
            this.departmentId = data.departmentID;
            // 选中最顶层组别后，无回到上一层
            if( data.departmentID == this.treeData[0].departmentID){
                this.parentDep={
                    departmentID:'',
                    departmentName: ''
                }
            }else{
                this.parentDep={
                    departmentID: data.parentID,
                    departmentName: data.parentName
                }
            }
            this.selectedDepartment = data;
            if (this.currentSelected === 1) {
                this.departmentPageIndex = 1;
                // this.getDepartments();
                this.search();
            } else {
                this.staffPageIndex = 1;
                // this.searchCompanyUserInfo();
                // 在切换组别时候 要带着条件进行筛选
                this.staffSearch();
            }
        },
        // 获取当前金币
        async getPropertyCoin() {
            let res = await this.axios.get(this.pub.getApi().GetDepartmentsTreeByParentID, {
                params: {
                    departmentID: this.parentId
                }
            });
            // console.log(res);
            let { code, message, result } = res.data;
            if (code === 0) {
                this.remainderPropertyCoin = result.remainderPropertyCoin;
                this.remainderDiamond = result.remainderDiamond;
            } else {
            }
        },
        // 购买金币
        async buyCoin() {
            this.buyCoinDialogVisible = true;
            this.$nextTick(() => {
                this.$refs.buyForm.resetFields();
                this.customeMoney = 0;
            });
            let res = await this.axios.get(this.pub.getApi().SearchPropertyCoinSet, {
                params: {
                    type: 'company'
                }
            });
            // console.log(res);
            let { code, message, result } = res.data;
            if (code === 0) {
                this.coinNumOptions = result;
            }
        },
        // 获取自定义金币的实际支付money
        getMoneny() {
            if (this.debouceTiemoutId !== null) {
                clearTimeout(this.debouceTiemoutId);
                this.debouceTiemoutId = null;
            }
            this.debouceTiemoutId = setTimeout(() => {
                // console.log('111')
                if (!this.buyCoinForm.buyCoinNum) {
                    this.customeMoney = '';
                    return;
                }
                this.axios
                    .post(`${this.pub.getApi().GetCustomPropertyCoinCountPriceOrder}?count=${this.buyCoinForm.buyCoinNum}`)
                    .then(res => {
                        // console.log(res)
                        let { code, result, msg } = res.data;
                        if (code === 0) {
                            this.customeMoney = result;
                        } else {
                            // this.$message({
                            // })
                        }
                    })
                    .catch(err => {
                        console.log('error', err);
                    });
            }, 1000);
        },
        // 确定购买金币
        makeSureBuyCoin() {
            if (this.submittingCoin) {return;}
            this.$refs.buyForm.validate(async valid => {
                if (valid) {
                    this.submittingCoin = true;
                    let url = '';
                    let data = null;
                    if (this.buyCoinForm.buyCoinNumId != 'self') {
                        url = this.pub.getApi().AddPropertyCoinOrder;
                        data = { coinId: this.buyCoinForm.buyCoinNumId };
                    } else {
                        url = `${this.pub.getApi().AddCustomPropertyCoinOrder}?count=${this.buyCoinForm.buyCoinNum}`;
                    }
                    try {
                        let res = await this.axios.post(url, data);
                        let { code, message, result } = res.data;
                        if (code === 0) {
                            // this.coinNumOptions = result;
                            this.$router.push({
                                path: '/coin/order-detail',
                                query: {
                                    orderId: result
                                }
                            });
                        } else {
                            this.submittingCoin = false;
                            this.$message({
                                type: 'error',
                                message: message,
                                showClose: true
                            });
                        }
                    } catch (err) {
                        this.submittingCoin = false;
                    }
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },
        // 購買磚石
        async buyDiamond() {
            this.buyDiamondDialogVisible = true;
            this.$nextTick(() => {
                this.$refs.buyDiamondForm.resetFields();
                this.customDiamondMoney = '';
            });
            let res = await this.axios.get(this.pub.getApi().SearchDiamondSet, {
                params: {
                    type: 'company'
                }
            });
            // console.log(res);
            let { code, message, result } = res.data;
            if (code === 0) {
                this.diamondNumOptions = result;
            }
        },
        // 获取自定义砖石实际money
        getCustomDiamond() {
            if (!this.buyDiamondForm.buyNum) {
                this.customDiamondMoney = '';
                return;
            }
            this.axios
                .post(`${this.pub.getApi().GetCustomDiamondCountPriceOrder}?count=${this.buyDiamondForm.buyNum}`)
                .then(res => {
                    // console.log(res)
                    let { code, result, msg } = res.data;
                    if (code === 0) {
                        this.customDiamondMoney = result;
                    } else {
                        // this.$message({
                        // })
                    }
                })
                .catch(err => {
                    console.log('error', err);
                });
        },
        // 确定购买砖石
        makeSureBuyDiamond() {
            if (this.submittingDiamond) {return;}
            this.$refs.buyDiamondForm.validate(async valid => {
                if (valid) {
                    this.submittingDiamond = true;
                    let url = '';
                    let data = null;
                    if (this.buyDiamondForm.buyNumId != 'self') {
                        url = this.pub.getApi().AddDiamondOrder;
                        data = { coinId: this.buyDiamondForm.buyNumId };
                    } else {
                        url = `${this.pub.getApi().AddCustomDiamondOrder}?count=${this.buyDiamondForm.buyNum}`;
                    }
                    try {
                        let res = await this.axios.post(url, data);
                        let { code, message, result } = res.data;
                        // console.log(result)
                        if (code === 0) {
                            // this.coinNumOptions = result;
                            this.$router.push({
                                path: '/coin/order-detail',
                                query: {
                                    orderId: result
                                }
                            });
                        } else {
                            this.submittingDiamond = false;
                            this.$message({
                                type: 'error',
                                message: message,
                                showClose: true
                            });
                        }
                    } catch (err) {
                        this.submittingDiamond = false;
                    }
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },
        // 查询组织
        search() {
            this.departmentPageIndex = 1;
            let data = {};
            if (this.status) {data.status = this.status;}
            if (this.coinNumMin) {data.remainderPropertyCoinStart = this.coinNumMin;}
            if (this.coinNumMax) {data.remainderPropertyCoinEnd = this.coinNumMax;}
            if (this.diamondNumMin) {data.remainderDiamondStart = this.diamondNumMin;}
            if (this.diamondNumMax) {data.remainderDiamondEnd = this.diamondNumMax;}
            this.getDepartments(data);
        },
        // 重置组织查询状态
        reset() {
            this.status = '';
            this.coinNumMin = '';
            this.coinNumMax = '';
            this.departmentPageIndex = 1;
            this.diamondNumMin = '';
            this.diamondNumMax = '';
            this.getDepartments();
        },
        // 表格选中
        handleSelectionChange(val) {
            this.selectedTableTr = val;
            // 组别转移钻石金币中，需要过滤掉当前选中的组
            if(this.selectedTableTr.length == 1){
                this.transferDepMon = false
                // this.transferDepOptions = this.setDisabled(JSON.parse(JSON.stringify(this.treeData)), this.selectedTableTr[0].departmentID);
            }else{
                this.transferDepMon = true
            }
        },
        // 金幣相關操作
        coinOperate(operateType,cType) {
            if (operateType !== 'assignAll') {
                if (this.selectedTableTr.length === 0) {
                    this.$message({
                        message: '未選擇組別或員工',
                        type: 'warning',
                        showClose: true
                    });
                    return;
                }
            }
            this.currencyType = cType;
            this.operateType = operateType;
            // 重置一些数据
            this.coinOperateDialogVisible = true;
            this.$nextTick(() => {
                this.$refs.coinOpetateform.resetFields();
            });
        },
        assignConfirm(){
            this.sixbtndia = false
            let type = this.currentSelected === 1 ? 'department' : 'staff';
            if (type === 'department') {
                // 组织
                this.sendCoin(this.operateForm.coinNum, 'superiorToLower', type);
            } else {
                // 员工
                this.sendCoin(this.operateForm.coinNum, 'organizationToUser', type);
            }
        },
        async sendCurrency(){
            this.sixbtndia = false
            let type = this.currentSelected === 1 ? 'department' : 'staff';
            // 分配 - 回收金币
            try {
                if(this.currencyType == 'coin'){
                    // 分配
                    if(this.operateType == 'assign'){
                        if (type === 'department') {
                            // 组织
                            await this.sendCoin(this.operateForm.coinNum, 'superiorToLower', type);
                        } else {
                            // 员工
                            await this.sendCoin(this.operateForm.coinNum, 'organizationToUser', type);
                        }
                    }else if(this.operateType == 'assignAll'){
                        if (type === 'department') {
                            // 組別
                            await this.bathSendCoin(this.operateForm.coinNum, true, 'superiorToLower', type);
                        } else {
                            // 員工
                            await this.bathSendCoin(this.operateForm.coinNum, true, 'organizationToUser', type);
                        }
                    }else{
                        // 回收
                        if (type === 'department') {
                            // 组织
                            await this.sendCoin(this.operateForm.coinNum, 'lowerToSuperior', type);
                        } else {
                            // 员工
                            await this.sendCoin(this.operateForm.coinNum, 'userToOrganization', type);
                        }
                    }
                }else{
                // 分配 - 回收钻石
                    if(this.operateType == 'assign'){
                        if (type === 'department') {
                            // 组织
                            await this.sendDiamond(this.diamondOperateForm.diamondNum, 'superiorToLower', type);
                        } else {
                            // 员工
                            await this.sendDiamond(this.diamondOperateForm.diamondNum, 'organizationToUser', type);
                        }
                    }else if(this.operateType == 'assignAll'){
                        if (type === 'department') {
                            // 組別
                            await this.bathSendDiamond(this.diamondOperateForm.diamondNum, true, 'superiorToLower', type);
                        } else {
                            // 員工
                            await this.bathSendDiamond(this.diamondOperateForm.diamondNum, true, 'organizationToUser', type);
                        }
                    }else{
                        if (type === 'department') {
                            // 组织
                            await this.sendDiamond(this.diamondOperateForm.diamondNum, 'lowerToSuperior', type);
                        } else {
                            // 员工
                            await this.sendDiamond(this.diamondOperateForm.diamondNum, 'userToOrganization', type);
                        }
                    }
                }
                this.acheiveAllTranCoin = true
            } catch (error) {
                this.acheiveAllTranCoin = false
            }
            this.getPropertyCoin()
            let selected = JSON.parse(JSON.stringify(this.selectedTableTr));
            // 已完成转移弹框数据筛选
                if(type === 'department'){
                    this.axios.post(this.pub.getApi().GetDepartments,
                        Object.assign(
                            {
                                parentID: this.departmentId,
                                pageIndex: 1,
                                pageCount: 100,
                            },
                        )
                    ).then((res)=>{
                        if(res.data.code === 0){
                            let tablesData = res.data.result.data;
                            if(this.operateType == 'assignAll'){
                                this.acheiveAllInStrDia = JSON.parse(JSON.stringify(tablesData));
                            }else{
                                // 勾选数据后选择分配的弹框 根据勾选的数据进行查询
                                this.acheiveAllInStrDia = tablesData.filter(item =>
                                    selected.some(a => a.departmentID === item.departmentID)
                                );

                            }
                        }
                    });
                }else{
                    // 全部分配成功后，获取转移员工/组别最新值
                    this.axios.post(this.pub.getApi().SearchCompanyUserInfo,{
                        departmentID: this.departmentId,
                        pageIndex: 1,
                        pageCount: 100,
                        coinMananger:true,
                        isCoinManangerCustomChoice:true,
                        searchName:'',
                    }).then((res)=>{
                        if(res.data.code === 0){ 
                            let staffsData = res.data.result.data;
                            if(this.operateType == 'assignAll'){
                                this.acheiveAllInStrDia = JSON.parse(JSON.stringify(staffsData))
                            }else{
                                this.acheiveAllInStrDia = staffsData.filter(item =>
                                    selected.some(a => a.accountID === item.accountID && a.departmentID === item.departmentID)
                                );
                            }
                        }
                    });
                }
            
        },
        // 分配金幣
        assignCoin() {
            let type = this.currentSelected === 1 ? 'department' : 'staff';
            this.selectedTableTrCopy = []
            this.$refs.coinOpetateform.validate(valid => {
                if (valid) {
                    let num = this.selectedTableTr.length;
                    this.selectedTableTrCopy = JSON.parse(JSON.stringify(this.selectedTableTr));
                    this.sixbtndia = true
                    // let contentText = '';
                    // if (type === 'department') {
                    //     if (num === 1) {
                    //         contentText = `${this.departmentName}為${this.selectedTableTr[0].departmentName}組別分配金幣${this.operateForm.coinNum}個`;
                    //     } else {
                    //         contentText = `${this.departmentName}為${num}個組別分配金幣各${this.operateForm.coinNum}個`;
                    //     }
                    // } else {
                    //     if (num === 1) {
                    //         contentText = `${this.departmentName}為${this.selectedTableTr[0].name}員工分配金幣${this.operateForm.coinNum}個`;
                    //     } else {
                    //         contentText = `${this.departmentName}為${num}個員工分配金幣各${this.operateForm.coinNum}個`;
                    //     }
                    // }
                    // this.$confirm(contentText, '分配金幣', {
                    //     confirmButtonText: '確認',
                    //     cancelButtonText: '取消',
                    //     dangerouslyUseHTMLString: true,
                    // })
                    //     .then(() => {
                    //         if (type === 'department') {
                    //             // 组织
                    //             this.sendCoin(this.operateForm.coinNum, 'superiorToLower', type);
                    //         } else {
                    //             // 员工
                    //             this.sendCoin(this.operateForm.coinNum, 'organizationToUser', type);
                    //         }
                    //     })
                    //     .catch(() => {
                    //         // this.$message({
                    //         //   type: "info",
                    //         //   message: "已取消分配"
                    //         // });
                    //     });
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },
        // 回收金幣
        backCoin() {
            let type = this.currentSelected === 1 ? 'department' : 'staff';
            this.selectedTableTrCopy = []
            this.$refs.coinOpetateform.validate(valid => {
                if (valid) {
                    let num = this.selectedTableTr.length;
                    this.selectedTableTrCopy = JSON.parse(JSON.stringify(this.selectedTableTr));
                    this.sixbtndia = true
                    // let contentText = '';
                    // if (type === 'department') {
                    //     if (num === 1) {
                    //         contentText = `您將回收${this.selectedTableTr[0].departmentName}組別的金幣共${this.operateForm.coinNum}個至${this.departmentName}`;
                    //     } else {
                    //         contentText = `您將回收${num}個組別的金幣各${this.operateForm.coinNum}個至${this.departmentName}`;
                    //     }
                    // } else {
                    //     if (num === 1) {
                    //         contentText = `您將回收${this.selectedTableTr[0].name}員工的金幣共${this.operateForm.coinNum}個至${this.departmentName}`;
                    //     } else {
                    //         contentText = `您將回收${num}個員工的金幣各${this.operateForm.coinNum}個至${this.departmentName}`;
                    //     }
                    // }
                    // this.$confirm(contentText, '回收金幣', {
                    //     confirmButtonText: '確認',
                    //     cancelButtonText: '取消'
                    // })
                    //     .then(() => {
                    //         if (type === 'department') {
                    //             // 组织
                    //             this.sendCoin(this.operateForm.coinNum, 'lowerToSuperior', type);
                    //         } else {
                    //             // 员工
                    //             this.sendCoin(this.operateForm.coinNum, 'userToOrganization', type);
                    //         }
                    //     })
                    //     .catch(() => {
                    //         // this.$message({
                    //         //   type: "info",
                    //         //   message: "已取消分配"
                    //         // });
                    //     });
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },
        // 分配或回收金币接口
        sendCoin(propertyCoin, sendCoinType, type) {
            return new Promise(async (resolve, reject) => { 
             
            let data = {
                sendCoins: [],
                sendCoinType: sendCoinType
            };
            if (type === 'department') {
                this.selectedTableTr.forEach(item => {
                    data.sendCoins.push({
                        receiveID: item.departmentID,
                        departmentID: item.departmentID,
                        propertyCoin: Number(propertyCoin)
                    });
                });
            }
            //  else if(type === 'transferDep'){
            //     const selectedId = Array.isArray(this.receiveTransID) ? this.receiveTransID[this.receiveTransID.length - 1] : this.receiveTransID[0];
            //     data.sendCoins.push({
            //         receiveID: selectedId,
            //         departmentID: this.selectedTableTr[0].departmentID,
            //         propertyCoin: Number(propertyCoin)
            //     });
            // }
            else{
                this.selectedTableTr.forEach(item => {
                    data.sendCoins.push({
                        receiveID: item.accountID,
                        departmentID: item.departmentID,
                        propertyCoin: Number(propertyCoin)
                    });
                });
            }
            // 发送请求
            let res = await this.axios.post(this.pub.getApi().SendCoin, data);
            // console.log(res);
            let { code, message, result } = res.data;
            if (code === 0) {
                resolve();
                this.getPropertyCoin();
                // let info = type === 'transferDep' ? '完成組別金幣轉移'  :'操作完成';
                // this.$message({
                //     message: info,
                //     type: 'success',
                //     showClose: true
                // });
                this.coinOperateDialogVisible = false;
                let params = this.getSearchParams();
                if (type === 'department' || type === 'transferDep') {
                    this.searchDepartment('out')
                    this.searchDepartment('in')
                    this.getDepartments(params);
                } else {
                    this.staffOptionsObtain()
                    this.searchCompanyUser('out')
                    this.searchCompanyUser('in')
                    this.searchCompanyUserInfo(params);
                }
            } else if (code === 2003) {
                this.$message({
                    message: '賬戶金幣餘額不足,分配失敗',
                    type: 'error',
                    showClose: true
                });
                reject();
            } else if (code === 2004) {
                this.$message({
                    message: '回收賬戶的金幣餘額不足,回收失敗',
                    type: 'error',
                    showClose: true
                });
                reject();
            } else {
                this.$message({
                    message,
                    type: 'error',
                    showClose: true
                });
                reject();
            }
        });
        },
        // 回收全部金币
        backAllCoin(operateType) {
            this.backAllCoinDialogVisible = true;
            this.operateType = operateType;
            this.$nextTick(() => {
                this.$refs.backAllForm.resetFields();
            });
        },
        makeSureBackAll() {
            let type = this.currentSelected === 1 ? 'department' : 'staff';
            this.$refs.backAllForm.validate(valid => {
                if (valid) {
                    let contentText = '';
                    if (type === 'department') {
                        // 組別
                        if (this.backAllForm.backAllMethod === 'all') {
                            contentText = `您將回收${this.selectedDepartment.departmentName}組別下的全部賬戶的全部金幣`;
                        } else {
                            contentText = `您將回收${this.selectedDepartment.departmentName}組別下的全部賬戶,各${this.backAllForm.backAllCoinNum}金幣`;
                        }
                    } else {
                        // 員工
                        if (this.backAllForm.backAllMethod === 'all') {
                            contentText = `您將回收${this.selectedDepartment.departmentName}組別下的全部員工的全部金幣`;
                        } else {
                            contentText = `您將回收${this.selectedDepartment.departmentName}組別下的全部員工,各${this.backAllForm.backAllCoinNum}金幣`;
                        }
                    }
                    this.$confirm(contentText, '回收全部(金幣)', {
                        confirmButtonText: '確認',
                        cancelButtonText: '取消'
                    })
                        .then(() => {
                            if (type === 'department') {
                                // 組別
                                if (this.backAllForm.backAllMethod === 'all') {
                                    this.bathSendCoin(0, true, 'lowerToSuperior', type);
                                } else {
                                    this.bathSendCoin(this.backAllForm.backAllCoinNum, false, 'lowerToSuperior', type);
                                }
                            } else {
                                // 員工
                                if (this.backAllForm.backAllMethod === 'all') {
                                    this.bathSendCoin(0, true, 'userToOrganization', type);
                                } else {
                                    this.bathSendCoin(this.backAllForm.backAllCoinNum, false, 'userToOrganization', type);
                                }
                            }
                        })
                        .catch(() => {
                            // this.$message({
                            //   type: "info",
                            //   message: "已取消删除"
                            // });
                        });
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },
        // 分配全部
        assignAll() {
            let type = this.currentSelected === 1 ? 'department' : 'staff';
            this.selectedTableTrCopy = []
            this.$refs.coinOpetateform.validate(valid => {
                if (valid) {
                    if(type === 'department'){
                         this.axios.post(
                            this.pub.getApi().GetDepartments,
                            Object.assign(
                                {
                                    parentID: this.departmentId,
                                    pageIndex: 1,
                                    pageCount: 100,
                                },
                            )
                        ).then((res)=>{
                            if(res.data.code === 0){
                                let tablesData = res.data.result.data;
                                this.selectedTableTrCopy = JSON.parse(JSON.stringify(tablesData));
                                this.sixbtndia = true
                            }
                        });
                    }else{
                        this.axios.post(this.pub.getApi().SearchCompanyUserInfo,{
                            departmentID: this.departmentId,
                            pageIndex: 1,
                            pageCount: 100,
                            coinMananger:true,
                            isCoinManangerCustomChoice:true,
                            searchName:'',
                            //status: "normal"
                        }).then((res)=>{
                            if(res.data.code === 0){ 
                                let staffsData = res.data.result.data;
                                this.selectedTableTrCopy = JSON.parse(JSON.stringify(staffsData))
                                this.sixbtndia = true
                            }
                        });
                    }

                    // let contentText;
                    // if (type === 'department') {
                    //     contentText = `您將分配${this.selectedDepartment.departmentName}組別下的全部賬戶，各${this.operateForm.coinNum}金幣`;
                    // } else {
                    //     contentText = `您將分配${this.selectedDepartment.departmentName}組別下的全部員工，各${this.operateForm.coinNum}金幣`;
                    // }
                    // this.$confirm(contentText, '分配全部(金幣)', {
                    //     confirmButtonText: '確認',
                    //     cancelButtonText: '取消'
                    // })
                    //     .then(() => {
                    //         if (type === 'department') {
                    //             // 組別
                    //             this.bathSendCoin(this.operateForm.coinNum, false, 'superiorToLower', type);
                    //         } else {
                    //             // 員工
                    //             this.bathSendCoin(this.operateForm.coinNum, false, 'organizationToUser', type);
                    //         }
                    //     })
                    //     .catch(() => {
                    //         // this.$message({
                    //         //   type: "info",
                    //         //   message: "已取消删除"
                    //         // });
                    //     });
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },
        // 分配全部或回收全部金币接口
        bathSendCoin(count, all, sendCoinType, type) {
            return new Promise(async (resolve, reject) => { 
           
            let data = {
                sendCoinType: sendCoinType
            };
            if (type === 'department') {
                // 组织
                data.departmentID = this.departmentId;
                if (count) {data.count = count;}
                data.all = all;
            } else {
                // 员工
                data.departmentID = this.departmentId;
                if (count) {data.count = count;}
                data.all = all;
            }
            // 发送请求
            let res = await this.axios.post(this.pub.getApi().BathSendCoin, data);
            // console.log("backAll", res);
            let { code, message, result } = res.data;
            if (code === 0) {
                resolve();

                this.getPropertyCoin();
                if(this.operateType === 'backAll'){
                    this.$message({
                        message: '操作完成',
                        type: 'success',
                        showClose: true
                    });
                }
                let params = this.getSearchParams();
                // 为保证下次打开转移钻石弹框为最新值
                await this.staffOptionsObtain()
                await this.searchCompanyUser('out',"notClear")
                // true代表为公司账户
                await this.searchCompanyUser('in',"notClear")
                await this.searchDepartment('out',"notClear")
                await this.searchDepartment('in',"notClear")
                if (type === 'department') {
                    if (this.operateType === 'backAll') {
                        this.backAllCoinDialogVisible = false;
                    } else {
                        this.coinOperateDialogVisible = false;
                    }
                    this.getDepartments(params);
                } else {
                    if (this.operateType === 'backAll') {
                        this.backAllCoinDialogVisible = false;
                    } else {
                        this.coinOperateDialogVisible = false;
                    }
                    this.searchCompanyUserInfo(params);
                }
            } else if (code === 2003) {
                this.$message({
                    message: '賬戶金幣餘額不足,分配失敗',
                    type: 'error',
                    showClose: true
                });
                reject();
            } else if (code === 2004) {
                this.$message({
                    message: '回收賬戶的金幣餘額不足,回收失敗',
                    type: 'error',
                    showClose: true
                });
                reject();
            } else if (code === 2023) {
                this.$message({
                    message: '操作無效,轉移總和為0',
                    type: 'error',
                    showClose: true
                });
                reject();
            } else {
                this.$message({
                    message,
                    type: 'error',
                    showClose: true
                });
                reject();
            }
        });
        },
        /* 砖石操作 */
        diamondOperate(operateType,cType) {
            if (operateType !== 'assignAll') {
                if (this.selectedTableTr.length === 0) {
                    this.$message({
                        message: '未選擇組別或員工',
                        type: 'warning',
                        showClose: true
                    });
                    return;
                }
            }
            this.operateType = operateType;
            this.currencyType = cType;
            // 重置一些数据
            this.diamondOperateDialogVisible = true;
            this.$nextTick(() => {
                this.$refs.diamondOpeerateform.resetFields();
            });
        },
        assignDiamond() {
            let type = this.currentSelected === 1 ? 'department' : 'staff';
            this.selectedTableTrCopy =[]
            this.$refs.diamondOpeerateform.validate(valid => {
                if (valid) {
                    let num = this.selectedTableTr.length;
                    this.selectedTableTrCopy = JSON.parse(JSON.stringify(this.selectedTableTr));
                    this.sixbtndia = true
                    // let contentText = '';
                    // if (type === 'department') {
                    //     if (num === 1) {
                    //         contentText = `${this.departmentName}為${this.selectedTableTr[0].departmentName}組別分配鑽石${this.diamondOperateForm.diamondNum}粒`;
                    //     } else {
                    //         contentText = `${this.departmentName}為${num}個組別分配鑽石各${this.diamondOperateForm.diamondNum}粒`;
                    //     }
                    // } else {
                    //     if (num === 1) {
                    //         contentText = `${this.departmentName}為${this.selectedTableTr[0].name}員工分配鑽石${this.diamondOperateForm.diamondNum}粒`;
                    //     } else {
                    //         contentText = `${this.departmentName}為${num}個員工分配鑽石各${this.diamondOperateForm.diamondNum}粒`;
                    //     }
                    // }
                    // this.$confirm(contentText, '分配鑽石', {
                    //     confirmButtonText: '確認',
                    //     cancelButtonText: '取消'
                    // })
                    //     .then(() => {
                    //         if (type === 'department') {
                    //             // 组织
                    //             this.sendDiamond(this.diamondOperateForm.diamondNum, 'superiorToLower', type);
                    //         } else {
                    //             // 员工
                    //             this.sendDiamond(this.diamondOperateForm.diamondNum, 'organizationToUser', type);
                    //         }
                    //     })
                    //     .catch(() => {
                    //         // this.$message({
                    //         //   type: "info",
                    //         //   message: "已取消分配"
                    //         // });
                    //     });
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },
        backDiamond() {
            let type = this.currentSelected === 1 ? 'department' : 'staff';
            this.selectedTableTrCopy = []
            this.$refs.diamondOpeerateform.validate(valid => {
                if (valid) {
                    let num = this.selectedTableTr.length;
                    this.selectedTableTrCopy = JSON.parse(JSON.stringify(this.selectedTableTr));
                    this.sixbtndia = true
                    // let contentText = '';
                    // if (type === 'department') {
                    //     if (num === 1) {
                    //         contentText = `您將回收${this.selectedTableTr[0].departmentName}組別的鑽石共${this.diamondOperateForm.diamondNum}粒至${this.departmentName}`;
                    //     } else {
                    //         contentText = `您將回收${num}個組別的鑽石各${this.diamondOperateForm.diamondNum}粒至${this.departmentName}`;
                    //     }
                    // } else {
                    //     if (num === 1) {
                    //         contentText = `您將回收${this.selectedTableTr[0].name}員工的鑽石共${this.diamondOperateForm.diamondNum}粒至${this.departmentName}`;
                    //     } else {
                    //         contentText = `您將回收${num}個員工的鑽石各${this.diamondOperateForm.diamondNum}粒至${this.departmentName}`;
                    //     }
                    // }
                    // this.$confirm(contentText, '回收鑽石', {
                    //     confirmButtonText: '確認',
                    //     cancelButtonText: '取消'
                    // })
                    //     .then(() => {
                    //         if (type === 'department') {
                    //             // 组织
                    //             this.sendDiamond(this.diamondOperateForm.diamondNum, 'lowerToSuperior', type);
                    //         } else {
                    //             // 员工
                    //             this.sendDiamond(this.diamondOperateForm.diamondNum, 'userToOrganization', type);
                    //         }
                    //     })
                    //     .catch(() => {
                    //         // this.$message({
                    //         //   type: "info",
                    //         //   message: "已取消分配"
                    //         // });
                    //     });
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },
        /* 分配回收 砖石接口 */
        sendDiamond(propertyCoin, sendCoinType, type) {
            return new Promise(async(resolve, reject) => { 
               
            let data = {
                sendCoins: [],
                sendCoinType: sendCoinType
            };
            if (type === 'department') {
                this.selectedTableTr.forEach(item => {
                    data.sendCoins.push({
                        receiveID: item.departmentID,
                        departmentID: item.departmentID,
                        propertyCoin: Number(propertyCoin)
                    });
                });
            } 
            // else if(type === 'transferDep'){
            //      const selectedId = Array.isArray(this.receiveTransID) ? this.receiveTransID[this.receiveTransID.length - 1] : this.receiveTransID[0];
            //     data.sendCoins.push({
            //         receiveID: selectedId,
            //         departmentID: this.selectedTableTr[0].departmentID,
            //         propertyCoin: Number(propertyCoin)
            //     });
            // }
             else {
                this.selectedTableTr.forEach(item => {
                    data.sendCoins.push({
                        receiveID: item.accountID,
                        departmentID: item.departmentID,
                        propertyCoin: Number(propertyCoin)
                    });
                });
            }
            // 发送请求
            let res = await this.axios.post(this.pub.getApi().SendDiamond, data);
            // console.log(res);
            let { code, message, result } = res.data;
            if (code === 0) {
                resolve()
                this.getPropertyCoin();
                // let info = type === 'transferDep' ? '完成組別鑽石轉移'  :'操作完成';
                // this.$message({
                //     message: info,
                //     type: 'success',
                //     showClose: true
                // });
                this.diamondOperateDialogVisible = false;
                let params = this.getSearchParams();
                if (type === 'department' || type === 'transferDep') {
                    this.searchDepartment('out')
                    this.searchDepartment('in')
                    this.getDepartments(params);
                } else {
                    this.staffOptionsObtain()
                    this.searchCompanyUser('out')
                    this.searchCompanyUser('in')
                    this.searchCompanyUserInfo(params);
                }
            } else if (code === 2003) {
                reject();
                this.$message({
                    message: '賬戶鑽石餘額不足,分配失敗',
                    type: 'error',
                    showClose: true
                });
            } else if (code === 2004) {
                this.$message({
                    message: '回收賬戶的鑽石餘額不足,回收失敗',
                    type: 'error',
                    showClose: true
                });
                reject();
            } else {
                this.$message({
                    message,
                    type: 'error',
                    showClose: true
                });
                reject();
            }
        });
        },
        assignAllDiamond() {
            let type = this.currentSelected === 1 ? 'department' : 'staff';
            this.$refs.diamondOpeerateform.validate(valid => {
                if (valid) {
                    if(type === 'department'){
                         this.axios.post(
                            this.pub.getApi().GetDepartments,
                            Object.assign(
                                {
                                    parentID: this.departmentId,
                                    pageIndex: 1,
                                    pageCount: 100,
                                },
                            )
                        ).then((res)=>{
                            if(res.data.code === 0){
                                let tablesData = res.data.result.data;
                                this.selectedTableTrCopy = JSON.parse(JSON.stringify(tablesData));
                                this.sixbtndia = true
                            }
                        });
                    }else{
                        this.axios.post(this.pub.getApi().SearchCompanyUserInfo,{
                            departmentID: this.departmentId,
                            pageIndex: 1,
                            pageCount: 100,
                            coinMananger:true,
                            isCoinManangerCustomChoice:true,
                            searchName:'',
                        }).then((res)=>{
                            if(res.data.code === 0){ 
                                let staffsData = res.data.result.data;
                                this.selectedTableTrCopy = JSON.parse(JSON.stringify(staffsData))
                                this.sixbtndia = true
                            }
                        });
                    }
                    
                    // let contentText;
                    // if (type === 'department') {
                    //     contentText = `您將分配${this.selectedDepartment.departmentName}組別下的全部賬戶，各${this.diamondOperateForm.diamondNum}粒鑽石`;
                    // } else {
                    //     contentText = `您將分配${this.selectedDepartment.departmentName}組別下的全部員工，各${this.diamondOperateForm.diamondNum}粒鑽石`;
                    // }
                    // this.$confirm(contentText, '分配全部(鑽石)', {
                    //     confirmButtonText: '確認',
                    //     cancelButtonText: '取消'
                    // })
                    //     .then(() => {
                    //         if (type === 'department') {
                    //             // 組別
                    //             this.bathSendDiamond(this.diamondOperateForm.diamondNum, false, 'superiorToLower', type);
                    //         } else {
                    //             // 員工
                    //             this.bathSendDiamond(this.diamondOperateForm.diamondNum, false, 'organizationToUser', type);
                    //         }
                    //     })
                    //     .catch(() => {
                    //         // this.$message({
                    //         //   type: "info",
                    //         //   message: "已取消删除"
                    //         // });
                    //     });
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },
        setDisabled(options, disabledId) {
            return options.map(option => {
                if (option.departmentID === disabledId) {
                    option.disabled = true;
                }
                if (option.childNode && option.childNode.length > 0) {
                    option.childNode = this.setDisabled(option.childNode, disabledId);
                }
                return option;
            });
        },
        // transferMoney(type){
        //     this.transferType = type
        //     this.showDepMoney = true
        //     // 弹框弹出时，清空错误提示
        //     this.showNumErr = false
        //     this.showMoneyCountErr = false
        //     this.showErrId = false
        //     this.showErrCoin = false
        //     this.propertyTransCoin = ''
        //     this.receiveTransID = []
        // },
        backAllDiamond(operateType) {
            this.backAllDiamondDialogVisible = true;
            this.operateType = operateType;
            this.$nextTick(() => {
                this.$refs.diamondBackAllForm.resetFields();
            });
        },
        // tranCoinMax(){
        //     if (!/^[1-9]\d*$/.test(this.propertyTransCoin)) {
        //         this.showMoneyCountErr = false
        //         this.showNumErr = true
        //         return
        //     } else{
        //         this.showNumErr = false
        //     }
        //     let transMoney = this.transferType == 'coin' ? 'remainderPropertyCoin' : 'remainderDiamond'
        //      // 输入的值不能超过最大值
        //     if(this.propertyTransCoin > this.selectedTableTr[0][transMoney]){
        //         this.showMoneyCountErr = true
        //         this.showErrCoin = false
        //     }else{
        //         this.showMoneyCountErr = false
        //     }
        // },
        findDepNameByDepID(options, departmentID) {
            for (const option of options) {
                if (option.departmentID === departmentID) {
                    return option.departmentName;
                }
                if (option.childNode && option.childNode.length > 0) {
                    const result = this.findDepNameByDepID(option.childNode, departmentID);
                    if (result) {
                        return result;
                    }
                }
            }
            return null;
        },
        // confirmDepTransfer(){
        //     if((!this.propertyTransCoin || this.propertyTransCoin == 0) && !this.receiveTransID.length){
        //         this.showErrCoin = true
        //         this.showErrId = true
        //         return
        //     }else if((!this.propertyTransCoin || this.propertyTransCoin == 0) && this.receiveTransID.length){
        //         this.showErrCoin = true
        //         this.showErrId = false
        //         return
        //     }else if(!this.receiveTransID.length && this.propertyTransCoin && this.propertyTransCoin != 0){
        //         this.showErrId = true
        //         this.showErrCoin = false
        //         return 
        //     }else if( this.propertyTransCoin && !/^[1-9]\d*$/.test(this.propertyTransCoin)){
        //         this.showNumErr = true
        //         return
        //     }
        //     if(this.propertyTransCoin && this.receiveTransID.length){
        //         this.showErrCoin = false
        //         this.showErrId = false
        //         this.showDepMoney = false
        //         const departmentName = this.findDepNameByDepID(this.transferDepOptions, this.receiveTransID[this.receiveTransID.length - 1]);
        //         this.$confirm(` 確認由【${this.selectedTableTr[0].departmentName}】轉移【${this.propertyTransCoin}】${this.transferType == 'coin' ? '金幣' : '鑽石' }予【${departmentName}】？`, '提示', {
        //         confirmButtonText: '確認',
        //         cancelButtonText: '取消',
        //         type: 'warning'
        //     })
        //         .then(() => {
        //             if(this.transferType == 'coin'){
        //                 this.sendCoin(this.propertyTransCoin, 'LowerToLower', 'transferDep');
        //             }else{
        //                 this.sendDiamond(this.propertyTransCoin, 'LowerToLower', 'transferDep');
        //             }
        //         })
        //         .catch(() => {
        //             this.$message({
        //                 type: 'info',
        //                 message: '已取消',
        //                 showClose: true
        //             });
        //         });
                
        //     }
        // },
        makeSureBackAllDiamond() {
            let type = this.currentSelected === 1 ? 'department' : 'staff';
            this.$refs.diamondBackAllForm.validate(valid => {
                if (valid) {
                    let contentText = '';
                    if (type === 'department') {
                        // 組別
                        if (this.diamondBackAllForm.backAllMethod === 'all') {
                            contentText = `您將回收${this.selectedDepartment.departmentName}組別下的全部賬戶的全部鑽石`;
                        } else {
                            contentText = `您將回收${this.selectedDepartment.departmentName}組別下的全部賬戶,各${this.diamondBackAllForm.backAllDiamondNum}粒鑽石`;
                        }
                    } else {
                        // 員工
                        if (this.diamondBackAllForm.backAllMethod === 'all') {
                            contentText = `您將回收${this.selectedDepartment.departmentName}組別下的全部員工的全部鑽石`;
                        } else {
                            contentText = `您將回收${this.selectedDepartment.departmentName}組別下的全部員工,各${this.diamondBackAllForm.backAllDiamondNum}粒鑽石`;
                        }
                    }
                    this.$confirm(contentText, '回收全部(鑽石)', {
                        confirmButtonText: '確認',
                        cancelButtonText: '取消'
                    })
                        .then(() => {
                            if (type === 'department') {
                                // 組別
                                if (this.diamondBackAllForm.backAllMethod === 'all') {
                                    this.bathSendDiamond(0, true, 'lowerToSuperior', type);
                                } else {
                                    this.bathSendDiamond(this.diamondBackAllForm.backAllDiamondNum, false, 'lowerToSuperior', type);
                                }
                            } else {
                                // 員工
                                if (this.diamondBackAllForm.backAllMethod === 'all') {
                                    this.bathSendDiamond(0, true, 'userToOrganization', type);
                                } else {
                                    this.bathSendDiamond(this.diamondBackAllForm.backAllDiamondNum, false, 'userToOrganization', type);
                                }
                            }
                        })
                        .catch(() => {
                            // this.$message({
                            //   type: "info",
                            //   message: "已取消删除"
                            // });
                        });
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },
        // 分配全部或回收全部砖石接口
        bathSendDiamond(count, all, sendCoinType, type) {
            return new Promise(async(resolve, reject) => { 
             
            let data = {
                sendCoinType: sendCoinType
            };
            if (type === 'department') {
                // 组织
                data.departmentID = this.departmentId;
                if (count) {data.count = count;}
                data.all = all;
            } else {
                // 员工
                data.departmentID = this.departmentId;
                if (count) {data.count = count;}
                data.all = all;
            }
            // 发送请求
            let res = await this.axios.post(this.pub.getApi().BathSendDiamond, data);
            // console.log("backAll", res);
            let { code, message, result } = res.data;
            if (code === 0) {
                resolve()
                this.getPropertyCoin();
                if(this.operateType === 'backAll'){
                    this.$message({
                        message: '操作完成',
                        type: 'success',
                        showClose: true
                    });
                }
                let params = this.getSearchParams();
                if (type === 'department') {
                    if (this.operateType === 'backAll') {
                        this.backAllDiamondDialogVisible = false;
                    } else {
                        this.diamondOperateDialogVisible = false;
                    }
                    this.getDepartments(params);
                } else {
                    if (this.operateType === 'backAll') {
                        this.backAllDiamondDialogVisible = false;
                    } else {
                        this.diamondOperateDialogVisible = false;
                    }
                    this.searchCompanyUserInfo(params);
                }
                await this.staffOptionsObtain()
                await this.searchCompanyUser('out',"notClear")
                // true代表为公司账户
                await this.searchCompanyUser('in',"notClear")
                await this.searchDepartment('out',"notClear")
                await this.searchDepartment('in',"notClear")
            } else if (code === 2003) {
                this.$message({
                    message: '賬戶鑽石餘額不足,分配失敗',
                    type: 'error',
                    showClose: true
                });
                reject();
            } else if (code === 2004) {
                this.$message({
                    message: '回收賬戶的鑽石餘額不足,回收失敗',
                    type: 'error',
                    showClose: true
                });
                reject();
            } else if (code === 2023) {
                this.$message({
                    message: '操作無效,轉移總和為0',
                    type: 'error',
                    showClose: true
                });
                reject();
            } else {
                this.$message({
                    message,
                    type: 'error',
                    showClose: true
                });
                reject();
            }
        });
        },
        // 通過id獲取組別信息
        async getDepartmentById(departmentID ,type) {
            let res = await this.axios.get(this.pub.getApi().GetDepartmentById, {
                params: {
                    departmentID
                }
            });
            let { code, result, message } = res.data;
            // console.log(res);
            if (code === 0) {
                // 通过点击回到上一层，也需记录父组别
                if(type == 'parentDep'){
                    if(this.treeData[0].departmentID != result.departmentID){
                        this.choseOrganization(result)
                    }else{
                        this.parentDep={
                            departmentID: '',
                            departmentName:''
                        }
                    }
                }else{
                    this.selectedDepartment = result;
                }
                // 员工管理页跳转进入金币钻石管理 需显示‘回到上一层’ 补充父节点
                if(this.$route.query.depId && type !== 'parentDep'){
                    if(this.treeData[0].departmentID != result.departmentID){
                        this.choseOrganization(result)
                    }else{
                        this.parentDep={
                            departmentID: '',
                            departmentName:''
                        }
                    }
                }   
                // 侧边节点命中
                setTimeout(() => { 
                    this.$refs.asideBar.setTreeCurrentNode(Number(this.departmentId));
                }, 500);
                // 展开 多层侧边 节点路径
                // let path = await this.findPath(this.treeData,departmentID); 
                // this.$refs.asideBar.setTreeExpandedAndSelected(path);
            }
        },
        findPath(tree, targetId, path = []) {
            for (let node of tree) {
                let currentPath = [...path, node.departmentID];
                if (node.departmentID == targetId) {
                    return currentPath;
                }
                if (node.childNode) {
                    let result = this.findPath(node.childNode, targetId, currentPath);
                    if (result) {return result;}
                }
            }
            return null;
        },
        // 员工查询
        staffSearch() {
            this.staffPageIndex = 1;
            let data = {};
            if (this.roleId) {data.roleId = this.roleId;}
            if (this.staffStatus) {data.status = this.staffStatus;}
            if (this.staffName) {data.searchName = this.staffName;}
            if (this.staffCoinNumMin) {data.remainderPropertyCoinStart = this.staffCoinNumMin;}
            if (this.staffCoinNumMax) {data.remainderPropertyCoinEnd = this.staffCoinNumMax;}
            if (this.staffDiamondNumMin) {data.remainderDiamondStart = this.staffDiamondNumMin;}
            if (this.staffDiamondNumMax) {data.remainderDiamondEnd = this.staffDiamondNumMax;}
            this.searchCompanyUserInfo(data);
        },
        staffReset() {
            this.roleId = '';
            this.staffStatus = '';
            this.staffName = '';
            this.staffCoinNumMin = '';
            this.staffCoinNumMax = '';
            this.staffPageIndex = 1;
            this.staffDiamondNumMin = '';
            this.staffDiamondNumMax = '';
            this.searchCompanyUserInfo();
        },
        // 获取搜素参数
        getSearchParams() {
            let data = {};
            if (this.currentSelected === 1) {
                if (this.status) {data.status = this.status;}
                if (this.coinNumMin) {data.remainderPropertyCoinStart = this.coinNumMin;}
                if (this.coinNumMax) {data.remainderPropertyCoinEnd = this.coinNumMax;}
                if (this.diamondNumMin) {data.remainderDiamondStart = this.diamondNumMin;}
                if (this.diamondNumMax) {data.remainderDiamondEnd = this.diamondNumMax;}
            } else {
                if (this.roleId) {data.roleId = this.roleId;}
                if (this.staffStatus) {data.status = this.staffStatus;}
                if (this.staffName) {data.searchName = this.staffName;}
                if (this.staffCoinNumMin) {data.remainderPropertyCoinStart = this.staffCoinNumMin;}
                if (this.staffCoinNumMax) {data.remainderPropertyCoinEnd = this.staffCoinNumMax;}
                if (this.staffDiamondNumMin) {data.remainderDiamondStart = this.staffDiamondNumMin;}
                if (this.staffDiamondNumMax) {data.remainderDiamondEnd = this.staffDiamondNumMax;}
            }
            return data;
        }
    },
    computed: {
        ...mapState(['permissions']),
        operateAlldisabled() {
            return this.selectedTableTr.length > 0;
        }
    }
};
</script>
<style lang="less" scoped>
@import '../../../assets/css/element-reset.less';
.account-header {
            padding-bottom: 20px;
            border-bottom: 1px solid #e2e2ea;
            line-height: 38px;
            position: absolute;
            left: 363px;
            .departmet-name,
            .coin-num,
            .diamond-num {
                //position: relative;
                font-size: 16px;
                color: #000000;
                letter-spacing: 0.1px;
                margin-right: 15px;
            }
            .pos-num{
                position:relative;
                .tringlebox{
                    position: absolute;
                    bottom: 28px;
                    left: 50%;
                    transform: translateX(-50%);
                    width: 0;
                    height: 0;
                    border-left: 8px solid transparent;
                    border-right: 8px solid transparent;
                    border-top: 10px solid #000000;
                    animation: fadeInOut 6s forwards;
                }
            }
            .anicon {
                display: inline-block;
                height: 50px;
                line-height: 50px;
                border-radius: 10px;
                z-index: -1;
                animation: blink 0.5s linear 10; /* 0.5秒一次，重复10次（共5秒） */
            }
            .custom-tooltip {
                position: absolute;
                top: -60px; /* 显示在选择框上方 */
                left: 52%;
                transform: translateX(-50%);
                background-color: #000000;
                color: #ffffff;
                padding: 2px 8px;
                border-radius: 10px;
                border: 1px solid #e1f3d8;
                box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
                z-index: 9999;
                white-space: nowrap;
                font-size: 14px;
               animation: fadeInOut 6s forwards;
            }
            @keyframes fadeInOut {
                0% { opacity: 0; transform: translate(-50%, 10px); }
                10% { opacity: 1; transform: translate(-50%, 0); }
                90% { opacity: 1; transform: translate(-50%, 0); }
                100% { opacity: 0; transform: translate(-50%, -10px); }
            }
            @keyframes blink {
                0%, 100% {
                    background-color: #FFF600;
                }
                50% {
                    background-color: transparent;
                }
            }
            .left_po{
                left:50%;
            }
            .el-button {
                width: 100px;
                height: 38px;
                font-size: 14px;
                padding: 12px 10px;
                border-radius: 10px;
                margin-left: 30px;
            }
            .el-button--warning {
                color: #fff;
                background-color: #fa6400;
                /* border-color: #409EFF; */
            }
            .btn-diamond {
                margin-left: 15px;
            }
        }


.icontit_box{
    background-color: #fff;
    width:330px;
    height: 35px;
    border-radius: 10px;
    padding: 20px 5px;
    position: absolute;
    z-index: 1;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    transition: width 0.3s ease;
}
.rig_box{
    margin-left: 15px;
}
.w_50{
    min-width: 50px
}
.flex_o{
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    .pad_5{
        padding: 0 5px;
        font-size:20px;
    }
    .pad_6{
        font-size:20px;

    }
    .mar_5{
        margin-left:5px;
        padding-top: 8px;
    }
    .flex_oclo{
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        // min-width: 68px;
        .gray_txt{
            color: #606266;
            font-size: 12px;
        }
        .bla_txt{
            color: #000;
            font-size: 13px;
            line-height: 33px;
        }
    }
}

.organization-account {
    width: 100%;
    position: relative;
    // padding-bottom: 20px;
    /deep/.el-form-item__error{
        color: #E50113;
    }
    .red{
        color: red;
    }
    .el-aside {
        background: #ffffff;
        border-radius: 10px;
        min-width:340px;
        transition: width 0.3s ease;
        overflow-x: hidden;
    }
    .el-main {
        padding: 0 0px 0px 20px;
        // 信息分類
        // .account-header {
        //     padding-bottom: 20px;
        //     border-bottom: 1px solid #e2e2ea;
        //     line-height: 38px;

        //     .departmet-name,
        //     .coin-num,
        //     .diamond-num {
        //         font-size: 16px;
        //         color: #000000;
        //         letter-spacing: 0.1px;
        //         margin-right: 15px;
        //     }
        //     .anicon {
        //         background-color: rgba(255, 255, 0, 0.5); /* 半透明黄色 */
        //         z-index: -1;
        //         animation: highlight 3s forwards;
        //         animation-duration: 4s;
        //     }
            
        //     .el-button {
        //         width: 100px;
        //         height: 38px;
        //         font-size: 14px;
        //         padding: 12px 10px;
        //         border-radius: 10px;
        //         margin-left: 30px;
        //     }
        //     .el-button--warning {
        //         color: #fff;
        //         background-color: #fa6400;
        //         /* border-color: #409EFF; */
        //     }
        //     .btn-diamond {
        //         margin-left: 15px;
        //     }
        // }
        .org-main {
            overflow: hidden;
            margin-top: 100px;
            // margin-top: 20px;
            // background-color: #fafcfe;
            // box-shadow: 0 1px 0 0 #f0f4fa, inset 0 1px 0 0 #f0f4fa;
            // border-radius: 10px;
            .uplevel{
                height: 25px;
                color: #0062FF;
                font-size:18px;
                margin-bottom: 10px;
                cursor: pointer;
                span{
                    padding-left:10px ;
                }
            }
            .classify-tab {
                span {
                    // display: inline-block;
                    // width: 140px;
                    // height: 49px;
                    text-align: center;
                    // line-height: 49px;
                    font-size: 22px;
                    color: #999999;
                    cursor: pointer;
                    &.active {
                        // background-color: #fff;
                        color: #000000;
                    }
                    &.activeGre{
                        color: #44DAA2;
                        font-weight: 700;

                    }
                    &.activeOrn{
                        color:#F96B24;
                        font-weight: 700;
                    }

                }
                .line {
                    display: inline-block;
                    width: 1px;
                    height: 22px;
                    margin: 0 22px;
                    background-color: #999999;
                    position: relative;
                    top: 3px;
                }
            }
            .tab-content {
                margin-top: 22px;
                .container-tissue,
                .container-staff {
                    .wraper {
                        background-color: #fff;
                        padding: 22px 20px;
                        box-shadow: 0 1px 0 0 #f0f4fa, inset 0 1px 0 0 #f0f4fa;
                        border-radius: 10px;
                    }
                }
            }
        }
        // 查詢條件
        .search-condition,
        .search-condition-staff {
            margin-bottom: 20px;
            .gre_point{
                display: inline-block;
                width: 10px;
                height: 10px;
                background-color: #07D379;
                border-radius: 50%;
                vertical-align: top;
            }
            .mr_15{
                margin-right: 15px;
            }
            .el-select,
            .el-cascader {
                width: 100px;
                height: 38px;
                margin-top: 10px;
                /deep/.el-input__inner {
                    background: #ffffff;
                    border-radius: 10px;
                    border: none;
                    height: 38px;
                    line-height: 38px;
                }
            }
            .el-select + span {
                margin-left: -5px;
            }
            .el-select.width100 {
                width: 100px;
            }
            .el-input {
                width: 100px;
                /deep/.el-input__inner {
                    background: #ffffff;
                    border-radius: 10px;
                    border: none;
                    height: 38px;
                    line-height: 38px;
                }
                &.width100 {
                    width: 100px;
                }
            }
            .el-input + .el-input {
                margin-right: 15px;
                margin-top: 10px;
            }
            span {
                margin-right: 5px;
                margin-left: 10px;
                color: #666666;
                font-size: 14px;
            }
            .gap {
                margin-right: 5px;
                margin-left: 5px;
            }
            .el-button {
                width: 88px;
                margin-left: 10px;
                margin-top: 10px;
                border-radius: 10px;
                height: 38px;
            }
            .el-button:first-of-type {
                margin-left: 20px;
            }
        }
        .btns {
            .coin,
            .diamond {
                display: inline-block;
                margin-top: 10px;
            }
            .coin {
                margin-right: 30px;
            }
            // margin-top: 20px;
            .coin .el-button {
                min-width: 80px;
                border-radius: 10px;
                padding: 12px 8px;
                &:focus,
                &:hover {
                    color: #fff;
                    border-color: none;
                    background-color: @btn-warning-color;
                }
                &.is-disabled {
                    color: #c0c4cc;
                    cursor: not-allowed;
                    background-image: none;
                    background-color: #fff;
                    border-color: #ebeef5;
                }
            }
            .diamond .el-button {
                min-width: 80px;
                border-radius: 10px;
                padding: 12px 8px;
                &:focus,
                &:hover {
                    color: #fff;
                    border-color: none;
                    background-color: @theme-color;
                }
                &.is-disabled {
                    color: #c0c4cc;
                    cursor: not-allowed;
                    background-image: none;
                    background-color: #fff;
                    border-color: #ebeef5;
                }
            }
            .el-button ~ .el-button {
                margin-left: 10px;
            }
        }
        // 數據列表
        .table-contain {
            border-radius: 10px;
            padding: 15px 0;
            background-color: #fff;
            margin-top: 10px;
            .tabtxt{
                color: #409EFF; 
                margin-left: 5px; 
                font-size: 14px;
            }
            .pagination {
                // text-align: center;
                margin-top: 20px;
                line-height: 35px;
                .count {
                    float: left;
                    span ~ span {
                        margin-left: 10px;
                    }
                }
                .el-pagination {
                    float: right;
                }
            }
        }
    }
    // 弹框
    .assign-dialog {
        .el-form-item {
            margin-bottom: 0px;
        }
        .el-form-item + .el-form-item {
            margin-top: 20px;
        }
        .el-input,
        .el-select {
            width: 320px;
        }
        .item {
            margin-bottom: 20px;
        }
        .label {
            display: inline-block;
            width: 100px;
        }
    }
    
    .btns_dep{
        color: #0064FF;
        background-color: #fff;
        width: 50%;
        font-size: 14px;
        height: 38px;
        line-height: 40px;
        display: inline-block;
        text-align: center;
        border: none;
    }
    .blu_btn{
        background-color: #0064FF;
        color: #fff;
    }
    .err_txt{
        font-size: 14px;
        color: #E50113;
        text-align: right;
        margin-right: 56px;
    }
    .err_txt_coin{
        font-size: 14px;
        color: #E50113;
        text-align: left;
        line-height: 3px;
        margin-left: 10px;
        vertical-align: text-top;
        margin-bottom: 15px;
        display: inline-block;
    }
    .coin_err{
        font-size: 13px;
        vertical-align: super;
    }
    .coin_num{
        margin: 20px 0 20px 36px;
    }
    .rec_box{
        margin-left:15px;
    }
    .out_dep{
        display: inline-block;
        // /deep/.el-form-item__error{
        //     left: 209px;
        // }
    }
    .in_dep{
        // /deep/.el-form-item__error{
        //     left: 216px;
        // }
        display: inline-block;
    }
    .coin_dep{
        /deep/.el-form-item__error{
            left: 106px;
            top:73%
        }
    }
    .multip{
        padding-bottom:10px ;
        color: #303030;
        font-size: 14px;
        font-weight: 700;
        margin-top:-10px;
    }
    .btns_box{
        width: 100px;
        height: 38px;
        border: 2px solid #0064FF;
        border-radius: 10px;
        display: inline-block;
        cursor: pointer;
        margin-right: 10px;
    }
    .depSta_box{
        max-height: 200px;
        overflow-y:auto ;
        overflow-x:hidden ;
    }
    .txt_box{
        height: 30px;
        width: 51px;
        border: 3px solid #606266;
        text-align: center;
        line-height: 30px;
        margin-bottom: 10px;
    }
    //.ach_box{
    //    height:160px
    //}
    .depSta_outbox{
        max-height: 200px;
        overflow-y:auto ; 
        overflow-x: hidden;
    }
    .box_txt{
        font-size: 14px;
        color: #444444;
        margin-bottom: 10px;
    }
    .ach_txt{
        font-size: 14px;
        color:#444444 ;
        font-weight: 700;
        margin-bottom: 10px;
    }
    .out_txt{
        font-size: 14px;
        color: #888888 ;
        margin-bottom: 10px;
    }
    .red_num{
        color: #E50113;
    }
    .gre_num{
        color: #2D942D;
    }
    .bor_lef{
        border-top-left-radius: 8px;
        border-bottom-left-radius: 8px;
    }
    .count_txt{
        color: #444444;
        font-size: 14px;
        font-weight: 700;
    }
    .count_txt_top{
        margin-top: 10px;
    }
    .count_txt_btm{
        margin-bottom: 12px;
        margin-top: 6px;
    }
    .red_count{
        font-size: 14px;
        color: #E50113;
    }
    .mar_l10{
        margin-right: 10px;
    }
    .mar_l20{
        margin-right: 24px;
    }
    .mar_r10{
        margin-right: 10px;
    }
    .bor_rig{
        border-top-right-radius: 8px;
        border-bottom-right-radius: 8px;
    }
    .transfer_dialog{
        /deep/.el-input__inner{
            border-radius: 10px;
        }
        .w_150{
            width:150px;
        }
    }
    .transfer_txtdialog{
        /deep/.el-dialog__body{
            padding-left: 50px;
            border-bottom: 1px solid #e2e2ea;
        }
    }
    // .transfer_dialog{
    //     /deep/.el-input__inner{
    //         border-radius: 10px;
    //     }
    //     /deep/.el-dialog__body{
    //         padding-left: 33px;
    //     }
    //     .txt_qi{
    //         margin-right: 14px;
    //         margin-left:10px;
    //     }
    //     .txt_coin{
    //         font-size: 14px;
    //         color: #696974;
    //     }
    //     .dep_box{
    //         .dep_txt{
    //             min-width:200px;
    //             max-width: 362px;
    //             height: auto;
    //             display: inline-block;
    //             background-color: #F1F1F5;
    //             vertical-align: middle;
    //             text-align: left;
    //             line-height: 38px;
    //             padding-left: 10px;
    //             border-radius: 10px;
    //         }
    //     }
    //     .dep_boxs{
    //         margin-top: 10px;
    //         .dep_cascader{
    //             max-width: 360px;
    //         }
    //     }
    //     .dep_boxe{
    //         margin-top: 10px;
    //         .boxe_input{
    //             width: 150px;
    //             margin-left: 10px;
    //         }
    //         .red_bor{
    //             /deep/.el-input__inner{
    //                 border-color: #F56C6C !important;
    //             }
    //         }
    //         .bla_bor{
    //             /deep/.el-input__inner{
    //                 border-color:#DCDFE6 !important;
    //             }
    //         }
    //         .boxe_coin{
    //             margin-left: 10px;
    //         }
    //     }
    //     .txt_err{
    //         margin-left:58px;
    //     }
    //     .err_txt{
    //         font-size: 12px;
    //         color: #E50113;
    //     }
    //     .err_mary{
    //         margin-left: 57px;
    //         margin-bottom: 10px;
    //     }
    //     .err_mart{
    //         margin-left: 57px;
    //     }

    // }
    .buy-dialog {
        .el-select {
            width: 250px;
        }
        .row {
            display: flex;
            .money {
                flex: 1;
                margin-left: 10px;
            }
            .el-input {
                width: 180px;
            }
        }
    }
    .clearfix:after {
        content: '';
        display: block;
        height: 0;
        clear: both;
        visibility: hidden;
    }
    .clearfix {
        /* 触发 hasLayout */
        zoom: 1;
    }
}
</style>
